import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      'nav.home': 'Home',
      'nav.about': 'About',
      'nav.services': 'Services',
      'nav.work': 'Work',
      'nav.process': 'Process',
      'nav.blog': 'Blog',
      'nav.startProject': 'Start Project',

      // Home Page
      'home.hero.title': 'Fast and affordable websites',
      'home.hero.subtitle': 'Starting up a business? We can help you get online fast and affordably.',
      'home.hero.cta': 'Start Your Project Today',
      'home.hero.scroll': 'Scroll to explore',
      'home.hero.seeWork': 'View Services',
      'home.hero.stats.fastValue': 'Fast',
      'home.hero.stats.fastLabel': 'Turnaround',
      'home.hero.stats.affordableValue': 'Affordable',
      'home.hero.stats.affordableLabel': 'Pricing',
      'home.hero.stats.satisfaction': 'Client Satisfaction',

      'home.hero.eyebrow': 'The time is now',

      // Services Overview
      'home.services.title': 'What We Offer',
      'home.services.subtitle': 'Speed, fair pricing, and a fit for teams of any size.',
      'home.services.highlights.quick.title': 'Quick turnarounds',
      'home.services.highlights.quick.description': 'Depending on the project, we can deliver a website in as as little as a few hours - or as long as a few weeks.',
      'home.services.highlights.nofees.title': 'No monthly fees',
      'home.services.highlights.nofees.description': 'You can start off on the free plan to get your online presence up and running, and then upgrade to a paid plan when you\'re ready, and using more bandwith.',
      'home.services.highlights.scale.title': 'Good for any business—big, small, or startup',
      'home.services.highlights.scale.description': 'From first-time founders to established brands, the process scales to your goals, budget, and how fast you want to move.',
      'home.services.webdev.title': 'Website Design & Development',
      'home.services.webdev.description': 'Custom, conversion-focused websites that don\'t just look good—they drive results. Built for speed, SEO, and your bottom line.',
      'home.services.branding.title': 'Hosting',
      'home.services.branding.description': 'Fast, secure, and reliable hosting on enterprise-grade cloud infrastructure. SSL, automated backups, and 99.99% uptime — handled for you.',
      'home.services.video.title': 'Security Audits',
      'home.services.video.description': 'Comprehensive security reviews of your website and infrastructure. We find the gaps, harden the stack, and keep your business out of the headlines.',
      'home.services.marketing.title': 'SEO',
      'home.services.marketing.description': 'Technical and on-page SEO that gets your business found. Page speed, structured data, content strategy, and measurable rankings.',
      'home.services.content.title': 'Mobile Apps',
      'home.services.content.description': 'Native-feel iOS and Android apps built with React Native. Beautiful, fast, and connected to the same backend as your website.',
      'home.services.automation.title': 'Networking Systems',
      'home.services.automation.description': 'Business networking design and management — secure Wi-Fi, VPNs, firewalls, and remote access setups for offices, studios, and storefronts.',
      
      // Why Choose Us
      'home.why.title': 'Why Choose FuturoCode Over Agencies?',
      'home.why.attention.title': 'One-on-One Attention',
      'home.why.attention.description': 'You work directly with me, not a junior designer or account manager. Every decision is made with your business goals in mind.',
      'home.why.price.title': 'Agency Quality, Freelancer Price',
      'home.why.price.description': 'Get the same level of expertise and attention to detail as top agencies, without the overhead costs and inflated prices.',
      'home.why.speed.title': 'Faster Turnaround',
      'home.why.speed.description': 'No red tape, no committee meetings, no delays. Projects move quickly because there\'s no bureaucracy to slow things down.',
      'home.why.results.title': 'Results-Focused Approach',
      'home.why.results.description': 'I don\'t just build pretty websites—I build websites that convert visitors into customers and grow your business.',
      
      // Features
      'home.features.custom.title': 'Custom Development',
      'home.features.custom.description': 'Tailored solutions that perfectly match your business needs and brand identity.',
      'home.features.mobile.title': 'Mobile-First Design',
      'home.features.mobile.description': 'Beautiful, responsive websites that look and work great on any device.',
      'home.features.performance.title': 'Performance Optimized',
      'home.features.performance.description': 'Lightning-fast loading times and smooth user experiences that keep visitors engaged.',
      
      // What I Do
      'home.whatido.title': 'What I Do',
      'home.whatido.description': 'I design and build modern, high-performance websites that don\'t just look good — they convert visitors into paying customers. Whether you\'re starting from scratch or want to upgrade an outdated site, I\'ll work with you one-on-one to create something that fits your goals, brand, and budget.',
      'home.whatido.custom': 'Fully custom websites (no templates or cookie-cutter designs)',
      'home.whatido.fast': 'Fast-loading, mobile-optimized, and SEO-ready',
      'home.whatido.secure': 'Secure, scalable, and built to grow with your business',
      'home.whatido.ux': 'Clean UX design that guides visitors to take action',
      'home.whatido.goal': 'Every website I build is made with a clear goal: to help you grow — more traffic, more trust, and more revenue.',
      
      // Who I Help
      'home.whohelp.title': 'Who I Help',
      'home.whohelp.description': 'I work with small business owners, local service providers, and freelancers who are ready to take their online presence seriously — without paying agency prices.',
      'home.whohelp.construction.title': 'Construction & Landscaping',
      'home.whohelp.construction.description': 'Construction, landscaping, and site clearing contractors who want to showcase their expertise and attract more local clients',
      'home.whohelp.services.title': 'Local Service Pros',
      'home.whohelp.services.description': 'Barbers, stylists, and local service professionals looking to build their brand and attract more customers',
      'home.whohelp.creatives.title': 'Creatives & Freelancers',
      'home.whohelp.creatives.description': 'Photographers, creatives, and digital freelancers who need a portfolio that converts visitors into clients',
      'home.whohelp.startups.title': 'Startup Founders',
      'home.whohelp.startups.description': 'Startup founders and new entrepreneurs who need a professional online presence to launch their business',
      'home.whohelp.business.title': 'Business Owners',
      'home.whohelp.business.description': 'Anyone who\'s tired of losing customers to bad websites and wants to stand out in their market',
      'home.whohelp.trades.title': 'Tradespeople',
      'home.whohelp.trades.description': 'Tradespeople and skilled laborers who want to showcase their expertise and attract more local clients',
      'home.whohelp.cta': 'If you\'re ready to stand out online, I\'m ready to build something powerful for you.',
      
      // Stats
      'home.stats.title': 'Why Your Website Matters',
      'home.stats.description': 'A powerful online presence isn\'t a luxury — it\'s your first impression. These real-world stats show why having a professional, high-performing website matters more than ever:',
      'home.stats.credibility.title': '75% of users judge a business\'s credibility based on website design',
      'home.stats.credibility.description': 'A modern, clean website isn\'t just nice — it\'s how people decide to trust you.',
      'home.stats.credibility.source': 'Source: Stanford Web Credibility Research',
      'home.stats.mobile.title': '60% of users won\'t return to a website that isn\'t mobile-friendly',
      'home.stats.mobile.description': 'If your site doesn\'t look great on mobile, you\'re losing over half your potential customers.',
      'home.stats.mobile.source': 'Source: Google Mobile UX Report',
      'home.stats.growth.title': 'Businesses with modern websites grow 2x faster',
      'home.stats.growth.description': 'A good website isn\'t a cost — it\'s a growth engine.',
      'home.stats.growth.source': 'Source: Deloitte Small Business Report',
      
      // Projects
      'home.projects.title': 'Latest Projects',
      'home.projects.demo': 'Live Demo',
      
      // Tech Stack
      'home.tech.title': 'Tech Stack',
      
      // Testimonials
      'home.testimonials.title': 'What Our Clients Say',
      'home.testimonials.subtitle':
        'Straight from founders and operators we\'ve partnered with.',
      
      // Testimonial Content
      'testimonials.sarah.name': 'Sarah Johnson',
      'testimonials.sarah.role': 'Construction Company Owner',
      'testimonials.sarah.content': 'FuturoCode transformed our outdated website into a lead-generating machine. We\'ve seen a 300% increase in online inquiries since the launch.',
      
      'testimonials.mike.name': 'Mike Chen',
      'testimonials.mike.role': 'Restaurant Owner',
      'testimonials.mike.content': 'The team at FuturoCode didn\'t just build a website—they built a digital experience that perfectly captures our brand. Our online orders increased by 150%.',
      
      'testimonials.lisa.name': 'Lisa Rodriguez',
      'testimonials.lisa.role': 'Photography Studio',
      'testimonials.lisa.content': 'From concept to launch, the process was seamless. Our new portfolio website has helped us book more high-value clients than ever before.',
      
      // Case Studies
      'home.casestudies.title': 'Real Results, Real Clients',
      'home.casestudies.challenge': 'Challenge:',
      'home.casestudies.solution': 'Solution:',
      'home.casestudies.results': 'Results:',
      
      // Case Study Projects
      'casestudies.construction.title': 'Construction Co. Website Redesign',
      'casestudies.construction.challenge': 'Outdated website losing potential clients to competitors',
      'casestudies.construction.solution': 'Modern, mobile-first design with lead capture forms',
      'casestudies.construction.results': '300% increase in online inquiries, 40% more phone calls',
      
      'casestudies.restaurant.title': 'Restaurant Online Ordering System',
      'casestudies.restaurant.challenge': 'No online presence, losing customers to delivery apps',
      'casestudies.restaurant.solution': 'Custom ordering website with integrated payment processing',
      'casestudies.restaurant.results': '150% increase in orders, 25% higher average order value',
      
      'casestudies.photography.title': 'Photography Portfolio Launch',
      'casestudies.photography.challenge': 'Generic portfolio not converting visitors to clients',
      'casestudies.photography.solution': 'Stunning visual portfolio with booking integration',
      'casestudies.photography.results': '200% more inquiries, 60% higher booking rate',
      
      // Contact
      'home.contact.title': 'Get in Touch',
      'home.contact.headline': 'Ready to change your life for the better?',
      'home.contact.description': 'Level up your lifestyle by leveling up your business.',
      'home.contact.button': 'Start Your Project',

      // Home — Pricing (bento section)
      'home.pricing.title': 'Plans built around your growth',
      'home.pricing.subtitle':
        'Agency-quality work, freelancer-friendly pricing.\nNo retainers locked behind contracts — cancel anytime.',
      'home.pricing.growthBadge': 'Growth',
      'home.pricing.recommendedLabel': 'Most recommended',
      'home.pricing.featuredPrice': '$200',
      'home.pricing.featuredPriceSuffix': 'Flat Fee ( Includes revision rounds )',
      'home.pricing.featuredCta': 'Get started',
      'home.pricing.launch.features': [
        '1-page conversion-focused website',
        'Includes revision rounds so we make sure it fits your needs',
        'Free hosting included—no monthly bill (unless you need more bandwidth—you can upgrade to a paid plan)',
        'Hosted on Google Cloud so you know it stays fast and reliable',
        'Ideal for startups, side hustles, or anyone who wants a credible one-page presence without the complexity.',
        'Social media links included',
      ],
      'home.pricing.scale.features': [
        'Unlimited pages & revisions',
        'Custom domain',
        'SEO optimization',
        'One on one support',
      ],
      'home.pricing.enterprise.features': [
        'Dedicated strategist & roadmap',
        'High-volume launches & integrations',
        'SLA-aligned support options',
        'Same-day escalation available',
      ],
      'home.pricing.cards.starter.badge': 'Starter',
      'home.pricing.cards.starter.priceLabel': '$150',
      'home.pricing.cards.starter.priceSuffix':
        'Flat Fee ( Includes revision rounds )',
      'home.pricing.cards.starter.cta': 'Start project',
      'home.pricing.cards.scale.badge': 'Scale',
      'home.pricing.cards.scale.priceLabel': '$5,000',
      'home.pricing.cards.scale.priceSuffix':
        'Flat Fee ( Includes revision rounds )',
      'home.pricing.cards.scale.cta': 'Talk to us',
      'home.pricing.cards.enterprise.badge': 'Enterprise',
      'home.pricing.cards.enterprise.priceLabel': 'Starting at $10,000 and up.',
      'home.pricing.cards.enterprise.cta': 'Contact sales',

      // Home — CTA marquee
      'home.ctaMarquee.title': 'Built for businesses on the move',
      'home.ctaMarquee.description':
        "From single-page sites to full-scale brand systems — agency-quality work, freelancer-fast turnaround. Let's build something that converts.",
      'home.ctaMarquee.primaryButton': 'START PROJECT',
      'home.ctaMarquee.secondaryButton': 'OUR SERVICES',
      'home.ctaMarquee.items': [
        'Founders & Startups',
        'Restaurants & Cafés',
        'Construction & Trades',
        'Photographers & Creatives',
        'Local Service Pros',
        'E-commerce Brands',
      ],

      // Home — Uptime / infrastructure
      'home.uptime.badge': 'All systems operational',
      'home.uptime.title': 'Always online. Built to stay up.',
      'home.uptime.subtitle':
        'We run your site on enterprise-grade cloud providers — and when needed, mirror it on private self-hosted infrastructure. If one goes down, your site stays up.',
      'home.uptime.stats': [
        {
          value: '99.9%',
          label: 'Target uptime',
          description:
            'Tracked across every project we ship and maintain.',
        },
        {
          value: '24/7',
          label: 'Monitoring',
          description:
            'Automatic alerts the moment latency or errors spike.',
        },
        {
          value: '<1m',
          label: 'Failover',
          description:
            'Auto-recovery on outage with cached static fallbacks.',
        },
      ],
      'home.uptime.multiCloud.title': 'Multi-cloud + self-hosted backup',
      'home.uptime.multiCloud.subtitle':
        'Your site never relies on a single point of failure.',
      'home.uptime.hostedOn': 'Hosted on',
      'home.uptime.selfHostedLabel': 'Self-hosted',

      // Home — Security strip
      'home.security.heroBadge': 'Security & Trust',
      'home.security.title':
        'Security isn\'t a feature.\nIt\'s the foundation.',
      'home.security.subtitle':
        'Every site we ship is engineered with state-of-the-art controls — zero trust, modern cryptography, continuous monitoring, and a hardened delivery pipeline. Built so your business never becomes a headline.',
      'home.security.metrics': [
        { label: 'Uptime SLA', value: '99.99%' },
        { label: 'Encryption', value: 'AES-256' },
        { label: 'TLS', value: '1.3' },
        { label: 'Mean detection time', value: '< 60s' },
      ],
      'home.security.pillars': [
        {
          title: 'Zero-Trust Architecture',
          description:
            'Every request, every session — continuously verified. Identity-aware proxies and least-privilege access by default.',
        },
        {
          title: 'End-to-End Encryption',
          description:
            'TLS 1.3 in transit, AES-256 at rest. HSTS, perfect forward secrecy, and modern cipher suites enforced everywhere.',
        },
        {
          title: 'Hardened Infrastructure',
          description:
            'Immutable deploys, signed artifacts, isolated runtimes, automated patching. Built on enterprise-grade cloud foundations.',
        },
        {
          title: 'DDoS & WAF Shielding',
          description:
            'Anycast edge filtering, bot mitigation, rate limiting, and an OWASP-tuned web application firewall standing in front of every site.',
        },
        {
          title: 'Continuous Monitoring',
          description:
            'Real-time threat intelligence, anomaly detection, SIEM correlation, and 24/7 alerting on suspicious activity.',
        },
        {
          title: 'Secrets & Key Management',
          description:
            'Hardware-backed key vaults, short-lived credentials, automatic rotation, and zero plaintext secrets in code or CI.',
        },
        {
          title: 'Identity & MFA',
          description:
            'SSO, passkeys, WebAuthn, and adaptive MFA. Phishing-resistant authentication for admins and customers alike.',
        },
        {
          title: 'Secure SDLC',
          description:
            'SAST, DAST, dependency scanning, signed commits, and policy-as-code gates wired into every pull request.',
        },
        {
          title: 'Privacy by Design',
          description:
            'GDPR & CCPA-ready data flows, consent management, regional residency, and minimal collection by default.',
        },
      ],
      'home.security.standardsTitle':
        'Aligned with the standards your buyers ask about',
      'home.security.standardsSubtitle':
        'Engineering practices mapped to the frameworks enterprise procurement teams care about.',
      'home.security.standards': [
        'SOC 2 Type II aligned',
        'ISO 27001 aligned',
        'GDPR ready',
        'CCPA ready',
        'HIPAA ready',
        'PCI DSS aware',
        'OWASP ASVS',
        'NIST CSF',
      ],
      'home.security.footerHint':
        'Want a deep dive? Ask us for our security one-pager and threat model.',

      // About Page
      'about.hero.title': 'About Me',
      'about.hero.subtitle': 'Building digital success stories, one business at a time',
      'about.intro.title': "I'm all about seeing small businesses win",
      'about.intro.lead': 'Because every win for you is a win for me. Your success drives everything I do.',
      'about.intro.paragraph1': 'At FuturoCode, I don\'t just build websites or run marketing campaigns. I build growth engines tailored to your business goals. I combine clean, cutting-edge design with smart tech and marketing strategies that get real results.',
      'about.intro.paragraph2': 'I understand the challenges of competing in today\'s digital world. That\'s why I focus on clear communication, custom solutions, and a partnership mindset. Your business deserves more than a cookie-cutter website — it deserves a digital presence that truly converts visitors into customers.',
      'about.intro.paragraph3': 'When you work with me, you get a developer and strategist who\'s invested in your success. Your growth is my mission, and together, we\'ll build a brand and platform that stands out, wins trust, and drives revenue.',
      'about.intro.closing': "Let's make your business the next big success story.",
      'about.values.title': 'What Drives Me',
      'about.highlights.title': 'Why Choose FuturoCode',
      'about.cta.title': 'Ready to build your success story?',
      'about.cta.subtitle': "Let's create something amazing together",
      'about.cta.button': 'Start Your Project',
      'about.cta.headline': 'Ready to change your life for the better?',
      'about.intro.minimal.headline': 'CERTAIN',
      'about.intro.minimal.line1': 'Rest easy knowing you are in capable hands,',
      'about.intro.minimal.line2': 'so you can focus on what matters.',
      'about.marquee.stats': [
        '100% Custom Built',
        '24/7 Support',
        '<2s Load Time',
        '∞ Iterations',
      ],
      'about.aria.statsMarquee': 'Key statistics',
      'about.aria.highlightsScene': 'Why choose FuturoCode',
      'about.spatial.pillarWord': 'Pillar',
      'about.spatial.left.label': 'Craft',
      'about.spatial.left.title': 'Designed to convert',
      'about.spatial.left.description':
        'Pixel-perfect interfaces engineered to turn visitors into customers. Brand identity, motion, and UX that feels inevitable.',
      'about.spatial.left.status': 'Active',
      'about.spatial.left.meta': '50+ pieces shipped',
      'about.spatial.left.featureBrand': 'Brand fidelity',
      'about.spatial.left.featureIterate': 'Iteration speed',
      'about.spatial.right.label': 'Code',
      'about.spatial.right.title': 'Built to last',
      'about.spatial.right.description':
        'Modern, performant codebases deployed with care. Sub-2-second loads, real-time analytics, and zero-downtime releases.',
      'about.spatial.right.status': 'Online',
      'about.spatial.right.meta': '200+ deployments',
      'about.spatial.right.featurePerf': 'Performance',
      'about.spatial.right.featureUptime': 'Uptime',

      // Values
      'values.growth.title': 'Growth-Focused',
      'values.growth.description': 'Every solution is designed to drive real business growth and measurable results.',
      'values.custom.title': 'Custom Solutions',
      'values.custom.description': 'No cookie-cutter approaches. Every project is tailored to your unique business needs.',
      'values.results.title': 'Results-Driven',
      'values.results.description': 'We focus on strategies and designs that convert visitors into loyal customers.',
      'values.partnership.title': 'Partnership Mindset',
      'values.partnership.description': 'Your success is our success. We\'re invested in your long-term growth.',

      // Highlights
      'highlights.strategy.title': 'Smart Strategy',
      'highlights.strategy.description': 'Combining cutting-edge design with intelligent marketing strategies',
      'highlights.communication.title': 'Clear Communication',
      'highlights.communication.description': 'Transparent processes and regular updates throughout your project',
      'highlights.results.title': 'Proven Results',
      'highlights.results.description': 'Track record of helping businesses stand out and drive revenue',

      // Services Page
      'services.hero.title': 'Our Services',
      'services.hero.subtitle': 'Comprehensive digital solutions to grow your business and establish a powerful online presence',
      'services.hero.badge': 'End-to-end solutions',
      'services.hero.viewAll': 'View all services',
      'services.offeringGrid.title': 'Speed. Security. Scale.',
      'services.offeringGrid.subtitle':
        'End-to-end services with the performance and reliability your business deserves.',
      'services.detailCard.startingLabel': 'Starting from',
      'services.detailCard.priceCustom': 'Custom quote',
      'services.detailCard.bookCall': 'Book a call',
      'services.cta.title': "Let's build your next big thing",
      'services.cta.subtitle': 'Ready to transform your business with professional digital solutions?',
      'services.cta.button': 'Start Your Project',

      // Services page — offerings grid (titles/descriptions: home.services.*)
      'services.offerings.webdev.tags': ['Custom builds', 'Speed & UX', 'SEO-ready', 'Conversions'],
      'services.offerings.webdev.overview': 'Custom, conversion-focused websites that don\'t just look good—they drive results. Built for speed, SEO, and your bottom line.',
      'services.offerings.webdev.benefits': [
        'Fast, accessible experiences that keep bounce rates down',
        'UX and IA structured around your real customer journeys',
        'Technical SEO baked in—not bolted on at the end',
        'Flexible stacks so you\'re never locked into a dead-end template'
      ],
      'services.offerings.webdev.process': [
        'Discovery — goals, audience, constraints, competitors',
        'Design & prototyping — layouts, typography, mobile-first UX',
        'Build & integrations — CMS, APIs, analytics, forms',
        'QA, launch & handoff — performance checks, redirects, docs'
      ],
      'services.offerings.webdev.technologies': ['React', 'JavaScript', 'Tailwind/CSS', 'Headless/CMS', 'Vercel/hosting-ready'],

      'services.offerings.hosting.tags': ['SSL/TLS', 'Backups', 'Uptime', 'Cloud'],
      'services.offerings.hosting.overview': 'Fast, secure, and reliable hosting on enterprise-grade cloud infrastructure. SSL, automated backups, and 99.99% uptime — handled for you.',
      'services.offerings.hosting.benefits': [
        'Managed certificates and sane security defaults',
        'Automated backups so recovery isn\'t a crisis',
        'Monitoring aligned with real SLA expectations—not marketing fluff',
        'Less time wrestling DNS and servers means more time on your business'
      ],
      'services.offerings.hosting.process': [
        'Environment sizing — traffic, geography, compliance',
        'Provision & migrate — DNS, redirects, HTTPS',
        'Harden — firewall rules, least-privilege, updates',
        'Observe — uptime checks, backup verification, alerting'
      ],
      'services.offerings.hosting.technologies': ['TLS/SSL', 'CDN', 'Object storage', 'Managed DB'],

      'services.offerings.security.tags': ['Assessments', 'Hardening', 'Compliance-minded', 'Actionable fixes'],
      'services.offerings.security.overview': 'Comprehensive security reviews of your website and infrastructure. We find the gaps, harden the stack, and keep your business out of the headlines.',
      'services.offerings.security.benefits': [
        'Threat modeling tuned to SMB exposure—not generic checklists',
        'Clear severity so you spend effort where risk is highest',
        'Hands-on remediation guidance across hosting, CMS, and plugins',
        'Less guesswork—know what broke, why it matters, and how to fix it'
      ],
      'services.offerings.security.process': [
        'Scope — assets, integrations, workflows, regulators if any',
        'Assess — configs, TLS, sessions, uploads, IAM, backups',
        'Report — prioritized issues with reproducible proof',
        'Remediate & verify — tighten stack, regression checks'
      ],
      'services.offerings.security.technologies': ['OWASP', 'TLS hardening', 'Headers/CSP planning', 'Log review'],

      'services.offerings.seo.tags': ['Technical SEO', 'Structured data', 'Content', 'Measurability'],
      'services.offerings.seo.overview': 'Technical and on-page SEO that gets your business found. Page speed, structured data, content strategy, and measurable rankings.',
      'services.offerings.seo.benefits': [
        'Crawlable, indexable foundations that compound over time',
        'Metadata & schema tuned to intent—not keyword stuffing',
        'Editorial workflows that translate expertise into searchable pages',
        'Instrumentation so improvements tie back to conversions'
      ],
      'services.offerings.seo.process': [
        'Baseline audit — crawling, SERP benchmarks, funnel mapping',
        'Quick wins vs roadmap — separates surgical fixes from content bets',
        'Implement — redirects, internals, snippets, UX blocks',
        'Measure — Search Console sanity, KPI reviews, iterative tuning'
      ],
      'services.offerings.seo.technologies': ['Search Console/Bing Webmaster', 'Structured data JSON-LD', 'Core Web Vitals', 'Analytics events'],

      'services.offerings.mobile.tags': ['React Native', 'iOS/Android', 'APIs', 'Ship faster'],
      'services.offerings.mobile.overview': 'Native-feel iOS and Android apps built with React Native. Beautiful, fast, and connected to the same backend as your website.',
      'services.offerings.mobile.benefits': [
        'Shared logic between platforms shrinks timelines and drift',
        'Navigation and motion that feel familiar on each OS',
        'Secure API integration parity with web products',
        'Release cadence suited to iterative feature delivery'
      ],
      'services.offerings.mobile.process': [
        'Product definition — personas, onboarding, offline needs',
        'UX/UI — reusable design system bridging web ↔ mobile',
        'Engineering — React Native, API contracts, QA devices',
        'Release — TestFlight/internal tracks, rollout, instrumentation'
      ],
      'services.offerings.mobile.technologies': ['React Native', 'JavaScript/TypeScript', 'REST/GraphQL', 'Push notifications'],

      // Service Packages
      'packages.starter.title': '🚀 Starter Website Package',
      'packages.starter.description': 'Perfect for small businesses and startups looking to establish their online presence',
      'packages.starter.budget': '$500 – $800',
      'packages.starter.features': [
        'Custom 1–3 page website',
        'Mobile-first design',
        'Basic SEO setup',
        'Contact form',
        'Simple brand color & typography selection'
      ],

      'packages.business.title': '💼 Business Growth Package',
      'packages.business.description': 'Comprehensive solution for established businesses ready to scale their online presence',
      'packages.business.budget': '$1,500 – $2,500',
      'packages.business.features': [
        '5–10 pages custom website',
        'Branding package (logo, color palette, typography)',
        'SEO optimization',
        'Professional photography or quality stock images',
        'Google Analytics & Search Console setup',
        'Blog section',
        'Basic video integration (e.g. hero video background)'
      ],

      'packages.creative.title': '🎥 Creative Media & Marketing Package',
      'packages.creative.description': 'Professional video content and social media assets to boost your brand\'s visual presence',
      'packages.creative.budget': '$1,200 – $2,000',
      'packages.creative.features': [
        '60-second business video commercial',
        'Drone footage (when available)',
        'Social media content clips',
        'Custom brand visuals for social media',
        'Optional blog writing add-on'
      ],

      'packages.full.title': '🧩 Full Digital Solution Package',
      'packages.full.description': 'Complete digital transformation for established businesses ready to dominate their market',
      'packages.full.budget': '$5,000 – $7,000',
      'packages.full.features': [
        'Fully custom website',
        'Advanced animations, interactive UI',
        'Full branding package',
        'Digital marketing strategy',
        'Content creation (photo/video)',
        'Business automation workflows (coming soon)',
        'Ongoing maintenance and analytics reporting',
        'Cybersecurity best practices'
      ],

      // Digital Marketing
      'digital.title': '🚀 Digital Marketing & Ads Management',
      'digital.description': 'Grow your business with strategic digital marketing and paid ads designed to reach the right audience and drive real results. Perfect for small businesses looking to boost visibility without wasting ad budget.',
      'digital.services.title': 'Included Services:',
      'digital.services.list': [
        'Facebook & Instagram Ads',
        'Google Search & Display Ads',
        'Audience research & targeting',
        'Custom ad creatives (images & copy)',
        'Conversion tracking & analytics reporting',
        'Ongoing campaign optimization',
        'Clear, monthly reports so you always know where your money goes'
      ],
      'digital.package.title': '💡 Starter Package',
      'digital.package.description': 'Perfect for small businesses looking to generate leads, sales, and brand awareness without breaking the bank.',
      'digital.pricing.setup': 'One-time setup fee:',
      'digital.pricing.setup.amount': '$500',
      'digital.pricing.monthly': 'Monthly management:',
      'digital.pricing.monthly.amount': '$300 - $500/month',
      'digital.pricing.budget': 'Recommended ad budget:',
      'digital.pricing.budget.amount': '$500–$1,500/month',
      'digital.pricing.note': '(paid directly to ad platforms)',
      'digital.included.title': 'What\'s Included:',
      'digital.included.list': [
        'Researching your client\'s business and competitors',
        'Setting up ad accounts (Facebook Business Manager, Google Ads)',
        'Writing ad copy and designing creative',
        'Creating campaigns, ad sets, and audiences',
        'Monitoring and tweaking campaigns at least weekly',
        'Analyzing results and preparing reports',
        'Communicating with your client regularly'
      ],
      'digital.communication.title': 'Communication:',
      'digital.communication.list': [
        'Weekly or bi-weekly calls',
        'Fast replies to questions'
      ],
      'digital.cta.button': 'Get Started with Digital Marketing',

      // Maintenance
      'maintenance.title': 'Maintenance & Support Retainer',
      'maintenance.description': 'Monthly site edits and updates • Security & performance checks • Content changes • Priority support',
      'maintenance.subtitle': 'Peace of mind for busy businesses post-launch.',
      'maintenance.basic.title': '⭐ Basic Maintenance',
      'maintenance.basic.price': '$50–$100/month',
      'maintenance.basic.description': '→ Perfect for small businesses with simple sites who rarely need changes.',
      'maintenance.standard.title': '🚀 Standard Maintenance',
      'maintenance.standard.price': '$150–$300/month',
      'maintenance.standard.description': '→ Good middle-ground for businesses that regularly update content or want peace of mind.',
      'maintenance.premium.title': '💼 Premium Maintenance',
      'maintenance.premium.price': '$400–$700+/month',
      'maintenance.premium.description': '→ For businesses running more complex sites or who want "on-call" services and first priority.',
      'maintenance.cta.button': 'Get Started with Maintenance',

      // Common
      'common.getStarted': 'Get Started',
      'common.budget': 'Budget',
      'common.clickForDetails': 'Click for details',
      'common.overview': 'Overview',
      'common.benefits': 'Key Benefits',
      'common.process': 'Our Process',
      'common.technologies': 'Technologies We Use',
      'common.deliverables': 'What You\'ll Receive',
      'common.services': 'Services Included',
      'common.tools': 'Tools & Platforms',
      'common.comingSoon': 'Coming Soon',
      'common.with': 'with',

      // Work Page
      'work.hero.title': 'Our Work',
      'work.hero.subtitle': 'Showcasing our latest projects and creative solutions that drive results',
      'work.cta.title': 'Like what you see?',
      'work.cta.subtitle': 'Let\'s create something amazing together',
      'work.cta.button': 'Start Your Project',

      // Work Categories
      'work.categories.all': 'All Projects',
      'work.categories.web': 'Web Design & Development',
      'work.categories.branding': 'Logos & Branding',
      'work.categories.video': 'Video & Commercial Work',
      'work.categories.experiments': 'Creative Experiments',

      // Work Common
      'work.featured': 'Featured',
      'work.comingSoon': 'Coming Soon',
      'work.viewDemo': 'View Demo',
      'work.clickForDetails': 'Click for details',
      'work.viewLiveDemo': 'View Live Demo',
      'work.startSimilarProject': 'Start Similar Project',

      // Work Modal
      'work.modal.overview': 'Overview',
      'work.modal.challenge': 'The Challenge',
      'work.modal.solution': 'Our Solution',
      'work.modal.features': 'Key Features',
      'work.modal.process': 'Our Process',
      'work.modal.technologies': 'Technologies Used',
      'work.modal.deliverables': 'Deliverables',
      'work.modal.services': 'Services Included',
      'work.modal.results': 'Results & Impact',
      'work.modal.applications': 'Applications',

      // Individual Projects
      'projects.siteclearing.title': 'Site Clearing & Demolition Website',
      'projects.siteclearing.description': 'A professional website for a site clearing and demolition company, featuring service showcases and contact forms.',
      'projects.siteclearing.overview': 'A comprehensive website for a site clearing and demolition company that showcases their services, expertise, and makes it easy for potential clients to get in touch. The site features a modern design with clear service descriptions, project galleries, and multiple contact options.',
      'projects.siteclearing.challenge': 'Create a professional online presence for a construction company that builds trust and generates leads in a competitive industry.',
      'projects.siteclearing.solution': 'Developed a responsive website with clear service offerings, project showcases, customer testimonials, and multiple lead capture points including contact forms and phone integration.',
      'projects.siteclearing.features': [
        'Responsive design that works on all devices',
        'Service showcase with detailed descriptions',
        'Project gallery with before/after images',
        'Customer testimonials and reviews',
        'Contact forms and phone integration',
        'SEO optimization for local search',
        'Fast loading times and performance optimization'
      ],
      'projects.siteclearing.process': [
        'Client consultation and requirements gathering',
        'Design mockups and wireframing',
        'Development and content creation',
        'Testing and optimization',
        'Launch and post-launch support'
      ],
      'projects.siteclearing.results': [
        'Increased online inquiries by 150%',
        'Improved local search rankings',
        'Enhanced professional credibility',
        'Streamlined lead generation process'
      ],
      'projects.siteclearing.client': 'Site Clearing & Demolition Co.',
      'projects.siteclearing.duration': '4 weeks',
      'projects.siteclearing.team': '2 developers, 1 designer',

      'projects.barber.title': 'Barber Booking Demo',
      'projects.barber.description': 'An interactive booking system for barber shops with appointment scheduling and client management.',
      'projects.barber.overview': 'A comprehensive booking system designed specifically for barber shops and hair salons. The platform allows customers to book appointments online, manage their profiles, and provides barbers with tools to manage their schedule and client base.',
      'projects.barber.challenge': 'Create an intuitive booking system that reduces no-shows and streamlines the appointment process for both customers and barbers.',
      'projects.barber.solution': 'Developed a full-stack application with real-time availability, automated reminders, and a user-friendly interface for both customers and service providers.',
      'projects.barber.features': [
        'Real-time appointment booking system',
        'Customer profile management',
        'Barber schedule management',
        'Automated appointment reminders',
        'Payment processing integration',
        'Review and rating system',
        'Mobile-responsive design'
      ],
      'projects.barber.process': [
        'Market research and user interviews',
        'UI/UX design and prototyping',
        'Full-stack development',
        'Testing and user feedback',
        'Launch and optimization'
      ],
      'projects.barber.technologies': ['React Frontend', 'Node.js Backend', 'MongoDB Database', 'Stripe Payments', 'Twilio SMS', 'AWS Hosting'],

      'projects.realestate.title': 'Real Estate Landing Page Demo',
      'projects.realestate.description': 'A high-converting landing page for real estate agents with property showcases and lead capture forms.',
      'projects.realestate.overview': 'A conversion-focused landing page designed specifically for real estate agents to showcase properties and capture qualified leads. The page features property galleries, virtual tours, and multiple lead capture points optimized for real estate sales.',
      'projects.realestate.challenge': 'Create a landing page that converts property viewers into qualified leads while showcasing properties effectively.',
      'projects.realestate.solution': 'Developed a high-converting landing page with property showcases, virtual tours, lead magnets, and strategic call-to-action placement.',
      'projects.realestate.features': [
        'Property showcase with image galleries',
        'Virtual tour integration',
        'Lead capture forms and popups',
        'Property search and filtering',
        'Agent profile and contact information',
        'Testimonials and social proof',
        'Mobile-optimized design'
      ],
      'projects.realestate.process': [
        'Conversion research and analysis',
        'Landing page design and copywriting',
        'Development and integration',
        'A/B testing and optimization',
        'Launch and performance monitoring'
      ],
      'projects.realestate.technologies': ['React with TypeScript', 'Firebase Backend', 'Google Maps API', 'Stripe Integration', 'Analytics Tracking'],

      'projects.futurocode.title': 'FuturoCode Brand Identity',
      'projects.futurocode.description': 'Complete brand identity package including logo design, color palette, and brand guidelines.',
      'projects.futurocode.overview': 'A comprehensive brand identity system for FuturoCode, establishing a professional and modern visual presence in the digital services industry. The brand identity reflects innovation, reliability, and forward-thinking approach.',
      'projects.futurocode.challenge': 'Create a distinctive brand identity that positions FuturoCode as a leading digital services provider while maintaining professionalism and approachability.',
      'projects.futurocode.solution': 'Developed a complete brand system including primary and secondary logos, color palette, typography, and comprehensive brand guidelines for consistent application.',
      'projects.futurocode.features': [
        'Primary and secondary logo designs',
        'Comprehensive color palette',
        'Typography system and hierarchy',
        'Brand guidelines and style guide',
        'Business card and stationery design',
        'Social media templates',
        'Brand application examples'
      ],
      'projects.futurocode.process': [
        'Brand research and positioning',
        'Logo concept development',
        'Visual identity creation',
        'Brand guidelines documentation',
        'Implementation and training'
      ],
      'projects.futurocode.deliverables': [
        'Primary Logo (Full Color)',
        'Secondary Logo (Monochrome)',
        'Brand Guidelines PDF',
        'Color Palette (RGB, CMYK, HEX)',
        'Typography System',
        'Business Card Design',
        'Social Media Templates',
        'Brand Style Guide'
      ],
      'projects.futurocode.results': [
        'Established professional brand presence',
        'Consistent visual communication',
        'Enhanced brand recognition',
        'Improved client trust and credibility'
      ],

      'projects.restaurant.title': 'Restaurant Logo Collection',
      'projects.restaurant.description': 'A collection of modern logo designs for various restaurant concepts and food brands.',
      'projects.restaurant.overview': 'A diverse collection of restaurant and food brand logos showcasing different styles, from elegant fine dining to casual eateries. Each logo is designed to reflect the unique personality and cuisine of the establishment.',
      'projects.restaurant.challenge': 'Create distinctive logos that capture the essence of different restaurant concepts while maintaining visual appeal and brand recognition.',
      'projects.restaurant.solution': 'Developed a range of logo styles using various design techniques, color palettes, and typography to suit different restaurant types and target audiences.',
      'projects.restaurant.features': [
        'Multiple logo design styles',
        'Custom typography and lettering',
        'Strategic color palette selection',
        'Scalable vector designs',
        'Brand personality alignment',
        'Industry-specific design elements',
        'Versatile application formats'
      ],
      'projects.restaurant.process': [
        'Concept research and mood boards',
        'Sketching and concept development',
        'Digital design and refinement',
        'Color and typography selection',
        'Finalization and file preparation'
      ],
      'projects.restaurant.styles': ['Modern Minimalist', 'Vintage Retro', 'Elegant Fine Dining', 'Casual Contemporary', 'Artisan Craft', 'International Cuisine'],
      'projects.restaurant.deliverables': [
        'Primary Logo Design',
        'Secondary Logo Variations',
        'Color Palette',
        'Typography Recommendations',
        'Usage Guidelines',
        'Digital and Print Files'
      ],

      'projects.commercial.title': 'Product Commercial Demo',
      'projects.commercial.description': 'Professional product commercials and promotional videos for e-commerce and retail brands.',
      'projects.commercial.overview': 'High-quality product commercials and promotional videos designed to showcase products effectively and drive sales. Our video production services include concept development, filming, editing, and post-production effects.',
      'projects.commercial.challenge': 'Create compelling video content that highlights product features, builds brand awareness, and drives customer engagement and sales.',
      'projects.commercial.solution': 'Developed comprehensive video production services with professional equipment, creative storytelling, and advanced post-production techniques to create impactful commercial content.',
      'projects.commercial.features': [
        'Product showcase and demonstration',
        'Brand storytelling and messaging',
        'Professional lighting and cinematography',
        'Motion graphics and visual effects',
        'Multiple video formats and lengths',
        'Social media optimization',
        'Analytics and performance tracking'
      ],
      'projects.commercial.process': [
        'Concept development and storyboarding',
        'Pre-production planning',
        'Filming and production',
        'Post-production and editing',
        'Client review and revisions',
        'Final delivery and optimization'
      ],
      'projects.commercial.services': [
        'Product Commercials (30s, 60s)',
        'Social Media Videos (15s, 30s)',
        'Product Demonstrations',
        'Brand Story Videos',
        'Testimonial Videos',
        'Behind-the-Scenes Content'
      ],
      'projects.commercial.equipment': ['4K Camera Systems', 'Professional Lighting', 'Drone Footage', 'Motion Graphics', 'Color Grading', 'Audio Enhancement'],

      'projects.drone.title': 'Drone Footage Collection',
      'projects.drone.description': 'Aerial photography and videography for real estate, events, and commercial applications.',
      'projects.drone.overview': 'Professional aerial photography and videography services using advanced drone technology. Our drone footage captures stunning perspectives for real estate, events, construction projects, and commercial applications.',
      'projects.drone.challenge': 'Provide high-quality aerial footage that adds value to various industries while ensuring safety, compliance, and creative excellence.',
      'projects.drone.solution': 'Utilized professional drone equipment with advanced camera systems, experienced pilots, and post-production expertise to deliver cinematic aerial content.',
      'projects.drone.features': [
        '4K aerial photography and videography',
        'Real estate property showcases',
        'Event coverage and documentation',
        'Construction progress tracking',
        'Commercial and industrial applications',
        'Custom flight paths and angles',
        'Professional color grading and editing'
      ],
      'projects.drone.process': [
        'Site assessment and planning',
        'Weather and safety evaluation',
        'Drone flight and capture',
        'Post-production editing',
        'Color grading and enhancement',
        'Final delivery and optimization'
      ],
      'projects.drone.applications': [
        'Real Estate Marketing',
        'Event Documentation',
        'Construction Progress',
        'Tourism and Travel',
        'Commercial Advertising',
        'Property Inspection'
      ],
      'projects.drone.equipment': ['DJI Mavic 3 Pro', '4K Camera Systems', 'Professional Gimbal', 'Advanced Flight Controllers', 'Post-Production Software'],

      'projects.futuristic.title': 'Futuristic UI Concept',
      'projects.futuristic.description': 'An experimental UI design exploring futuristic interfaces and next-generation user experiences.',
      'projects.futuristic.overview': 'An experimental UI design project exploring futuristic interface concepts and next-generation user experiences. This project pushes the boundaries of traditional web design with innovative interactions, 3D elements, and cutting-edge technologies.',
      'projects.futuristic.challenge': 'Create a futuristic user interface that demonstrates innovative design concepts while maintaining usability and performance standards.',
      'projects.futuristic.solution': 'Developed an experimental UI using advanced web technologies including Three.js, WebGL, and modern CSS animations to create immersive and interactive experiences.',
      'projects.futuristic.features': [
        '3D interactive elements',
        'Advanced animations and transitions',
        'Gesture-based interactions',
        'Immersive visual effects',
        'Responsive design adaptation',
        'Performance optimization',
        'Cross-browser compatibility'
      ],
      'projects.futuristic.process': [
        'Concept development and research',
        '3D modeling and design',
        'Interactive prototype development',
        'Performance optimization',
        'Testing and refinement',
        'Documentation and showcase'
      ],
      'projects.futuristic.technologies': [
        'Figma for Design',
        'Three.js for 3D Graphics',
        'WebGL for Rendering',
        'GSAP for Animations',
        'React for Interface',
        'Webpack for Build'
      ],
      'projects.futuristic.innovations': [
        'Holographic UI Elements',
        'Voice-Activated Controls',
        'Gesture Recognition',
        'AI-Powered Interactions',
        'Immersive Environments',
        'Predictive Interfaces'
      ],

      'projects.animation.title': '3D Homepage Animation Prototype',
      'projects.animation.description': 'Interactive 3D animations and visual effects for modern web experiences.',
      'projects.animation.overview': 'A prototype showcasing the potential of 3D animations and visual effects in modern web design. This project demonstrates how 3D elements can enhance user engagement and create memorable online experiences.',
      'projects.animation.challenge': 'Create engaging 3D animations that enhance user experience without compromising website performance or accessibility.',
      'projects.animation.solution': 'Developed optimized 3D animations using Three.js and GSAP, focusing on performance, accessibility, and cross-device compatibility while creating visually stunning effects.',
      'projects.animation.features': [
        'Interactive 3D scene navigation',
        'Smooth animation transitions',
        'Responsive 3D elements',
        'Performance-optimized rendering',
        'Touch and mouse interactions',
        'Progressive enhancement',
        'Accessibility considerations'
      ],
      'projects.animation.process': [
        '3D concept and storyboarding',
        'Scene modeling and setup',
        'Animation development',
        'Performance optimization',
        'User testing and refinement',
        'Documentation and deployment'
      ],
      'projects.animation.technicalSpecs': [
        'Three.js for 3D Rendering',
        'GSAP for Animation Control',
        'WebGL for Hardware Acceleration',
        'Responsive Design Principles',
        'Progressive Web App Features',
        'Cross-Browser Compatibility'
      ],
      'projects.animation.applications': [
        'Interactive Product Showcases',
        'Immersive Brand Experiences',
        'Educational Visualizations',
        'Entertainment Platforms',
        'Virtual Tours',
        'Interactive Storytelling'
      ],

      // Process Page
      'process.title': 'My Process',
      'process.discovery.title': 'Discovery & Planning',
      'process.discovery.description': 'I learn about your business, audience, and goals so we can build something that works — not just looks pretty.',
      'process.discovery.bullet1': 'Businesses that define clear user personas convert 2–5x higher.',
      'process.discovery.bullet2': 'I ask questions like: What\'s your #1 offer? What makes people hesitate to buy?',
      'process.discovery.bullet3': 'I research your competitors and highlight what makes you different.',
      'process.design.title': 'Design & Development',
      'process.design.description': 'I create a website that\'s both beautiful and functional, optimized for conversions and user experience.',
      'process.design.bullet1': 'Mobile-first, responsive design that works on all devices',
      'process.design.bullet2': 'Fast loading times and optimized performance',
      'process.design.bullet3': 'Clear calls-to-action and conversion paths',
      'process.launch.title': 'Launch & Optimization',
      'process.launch.description': 'I ensure everything works perfectly and help you get the most out of your new website.',
      'process.launch.bullet1': 'Thorough testing across all devices and browsers',
      'process.launch.bullet2': 'SEO optimization for better visibility',
      'process.launch.bullet3': 'Analytics setup to track performance',

      // ScrollExperience Component
      'scrollExperience.hero.title': 'How I Build Websites That Actually Perform',
      'scrollExperience.hero.subtitle': 'Here\'s the step-by-step system I use to design and develop custom, high-converting websites — built for speed, SEO, mobile, and your business goals.',
      'scrollExperience.stats.stat1': 'The average user forms an opinion of your website in 0.05 seconds.',
      'scrollExperience.stats.stat2': 'Mobile-first websites convert 27% higher than non-optimized ones.',
      'scrollExperience.stats.stat3': 'A 1-second delay in page load can reduce conversions by up to 20%.',
      
      // Process Steps
      'scrollExperience.steps.discovery.title': 'Discovery & Planning',
      'scrollExperience.steps.discovery.description': 'I learn about your business, audience, and goals so we can build something that works — not just looks pretty.',
      'scrollExperience.steps.discovery.fact1': 'Businesses that define clear user personas convert 2–5x higher.',
      'scrollExperience.steps.discovery.fact2': 'I ask questions like: What\'s your #1 offer? What makes people hesitate to buy?',
      'scrollExperience.steps.discovery.fact3': 'I research your competitors and highlight what makes you different.',
      
      'scrollExperience.steps.design.title': 'Design & Mockups',
      'scrollExperience.steps.design.description': 'I design a layout that reflects your brand, keeps users engaged, and guides them toward action — using proven UX strategies.',
      'scrollExperience.steps.design.fact1': 'Users spend 74% of their time viewing the first two screenfuls of a page.',
      'scrollExperience.steps.design.fact2': 'I use layouts based on Z-patterns and F-patterns, proven to guide the eye naturally toward CTAs.',
      'scrollExperience.steps.design.fact3': 'I create mobile-first designs — since more than 58% of all web traffic comes from mobile.',
      
      'scrollExperience.steps.development.title': 'Development',
      'scrollExperience.steps.development.description': 'I hand-code your site for speed, SEO, and responsiveness — avoiding bloated templates.',
      'scrollExperience.steps.development.fact1': 'Sites that load in under 2 seconds have a 15% higher conversion rate.',
      'scrollExperience.steps.development.fact2': 'I use clean HTML/CSS/JS, and tools like Lighthouse to keep performance scores high.',
      'scrollExperience.steps.development.fact3': 'I build SEO foundations: proper headings, image alt tags, and structured data when needed.',
      
      'scrollExperience.steps.review.title': 'Review & Revisions',
      'scrollExperience.steps.review.description': 'I send you a test version for review, and we refine it together until it\'s dialed in just right.',
      'scrollExperience.steps.review.fact1': 'Clients who are involved in feedback cycles are 80% more satisfied with the final product.',
      'scrollExperience.steps.review.fact2': 'I include 1–2 revision rounds in the process to fine-tune design, content, and flow.',
      
      'scrollExperience.steps.launch.title': 'Launch & Support',
      'scrollExperience.steps.launch.description': 'I launch the site, connect your domain, add SSL, optimize for search, and offer optional support for ongoing changes.',
      'scrollExperience.steps.launch.fact1': 'I make sure your site is submitted to Google Search Console for indexing.',
      'scrollExperience.steps.launch.fact2': 'I test for browser/device compatibility.',
      'scrollExperience.steps.launch.fact3': 'Post-launch support helps with updates, analytics, or content tweaks — just like a real team member.',
      
      // CTA Section
      'scrollExperience.cta.title': 'Now that you\'ve seen how I do it — want to see it in action?',
      'scrollExperience.cta.subtitle': 'Let\'s build something powerful together.',
      'scrollExperience.cta.button': 'Start Your Project',

      // Blog Page
      'blog.hero.title': 'FuturoCode Blog',
      'blog.hero.subtitle': 'Insights, tips, and strategies to help your business thrive in the digital world',
      'blog.search.placeholder': 'Search articles...',
      'blog.noPosts.title': 'No posts found',
      'blog.noPosts.subtitle': 'Try adjusting your search or filter criteria',
      'blog.cta.title': 'Want insights like this for your business?',
      'blog.cta.subtitle': 'Let\'s work together to create a digital strategy that drives results',
      'blog.cta.button': 'Start Your Project',
      'blog.featured.badge': 'Featured Post',
      'blog.readMore': 'Read More',
      'blog.readFullArticle': 'Read Full Article',

      // Blog Categories
      'blog.categories.all': 'All Posts',
      'blog.categories.webDesign': 'Web Design',
      'blog.categories.branding': 'Branding',
      'blog.categories.marketing': 'Digital Marketing',
      'blog.categories.cybersecurity': 'Cybersecurity',
      'blog.categories.business': 'Business Tips',

      // Blog Posts
      'blog.posts.websiteLosingCustomers.title': 'Why Your Website Is Losing You Customers (and How to Fix It)',
      'blog.posts.websiteLosingCustomers.excerpt': 'Discover the common website mistakes that drive potential customers away and learn proven strategies to convert visitors into loyal clients.',
      'blog.posts.websiteLosingCustomers.content': `
        In today's digital age, your website is often the first impression potential customers have of your business. A poorly designed or outdated website can cost you valuable customers before you even have a chance to showcase your products or services. Let's dive into the common mistakes that might be driving visitors away and, more importantly, how to fix them.

        1. Slow Loading Times
        Studies show that 53% of mobile users abandon sites that take longer than 3 seconds to load. Here's how to speed up your site:
        - Optimize images and use modern formats like WebP
        - Implement caching strategies
        - Minimize JavaScript and CSS files
        - Use a content delivery network (CDN)

        2. Poor Mobile Experience
        With over 60% of web traffic coming from mobile devices, a mobile-unfriendly website is a major liability. Essential fixes include:
        - Implement responsive design that adapts to all screen sizes
        - Ensure text is readable without zooming
        - Make buttons and links easily tappable
        - Test your site on multiple devices

        3. Unclear Value Proposition
        Visitors should immediately understand what you offer and why they should choose you. To improve:
        - Place your value proposition above the fold
        - Use clear, benefit-focused headlines
        - Include social proof (testimonials, reviews)
        - Highlight your unique selling points

        4. Complicated Navigation
        If users can't find what they're looking for quickly, they'll leave. Solutions include:
        - Simplify your menu structure
        - Implement a clear hierarchy
        - Add a search function
        - Use descriptive labels

        5. Lack of Clear Call-to-Action (CTA)
        Without clear direction, visitors won't know what to do next. Improve by:
        - Making CTAs visible and compelling
        - Using action-oriented language
        - Placing CTAs strategically throughout the page
        - Testing different colors and positions

        6. Outdated Design
        An outdated website can harm your credibility. Modern design principles to implement:
        - Use clean, modern typography
        - Implement adequate white space
        - Choose a contemporary color scheme
        - Add subtle animations and interactions

        7. Missing Trust Signals
        Build trust with potential customers by:
        - Displaying security badges
        - Showing customer testimonials
        - Including case studies
        - Highlighting industry certifications

        8. Poor Content Organization
        Well-organized content helps visitors find information easily:
        - Use clear headings and subheadings
        - Implement logical content hierarchy
        - Break up text with bullet points
        - Include relevant images and media

        9. Lack of Performance Optimization
        A slow, unoptimized site frustrates users. Key optimizations:
        - Compress images and media
        - Minimize HTTP requests
        - Enable browser caching
        - Use lazy loading for images

        10. No Analytics or Tracking
        Without data, you can't improve. Implement:
        - Google Analytics
        - Heat mapping tools
        - Conversion tracking
        - User behavior analytics

        Taking Action
        Start by auditing your website against these common issues. Prioritize fixes based on:
        1. Impact on user experience
        2. Ease of implementation
        3. Potential return on investment

        Remember, your website should be a powerful tool for converting visitors into customers, not a barrier to entry. Regular updates and maintenance are essential to keep your site performing at its best.

        Need help optimizing your website? Contact us for a free website audit and personalized recommendations to boost your conversion rates.
      `,
      'blog.posts.websiteLosingCustomers.tags': ['Web Design', 'User Experience', 'Conversion'],

      'blog.posts.brandTrust.title': 'How to Build a Brand That People Trust',
      'blog.posts.brandTrust.excerpt': 'Learn the essential elements of brand building that create lasting trust and loyalty with your target audience.',
      'blog.posts.brandTrust.content': 'Building a trustworthy brand isn\'t just about having a nice logo or catchy slogan. It\'s about creating a consistent experience that aligns with your values and resonates with your audience...',
      'blog.posts.brandTrust.tags': ['Branding', 'Trust', 'Brand Identity'],

      'blog.posts.cybersecurity101.title': 'Cybersecurity 101: Protecting Your Small Business Online',
      'blog.posts.cybersecurity101.excerpt': 'Essential cybersecurity practices every small business owner should implement to protect their digital assets and customer data.',
      'blog.posts.cybersecurity101.content': 'In today\'s digital landscape, cybersecurity isn\'t just for large corporations. Small businesses are increasingly targeted by cybercriminals, making security measures essential for survival...',
      'blog.posts.cybersecurity101.tags': ['Cybersecurity', 'Small Business', 'Data Protection'],

      'blog.posts.entrepreneurMistakes.title': '5 Mistakes New Entrepreneurs Make With Their Online Presence',
      'blog.posts.entrepreneurMistakes.excerpt': 'Avoid these common pitfalls that can derail your business\'s online success and learn how to build a strong digital foundation.',
      'blog.posts.entrepreneurMistakes.content': 'Starting a business is exciting, but many new entrepreneurs make critical mistakes with their online presence that can hinder growth and success...',
      'blog.posts.entrepreneurMistakes.tags': ['Entrepreneurship', 'Online Presence', 'Business Strategy'],

      'blog.posts.localSEO.title': 'The Power of Local SEO for Service-Based Businesses',
      'blog.posts.localSEO.excerpt': 'Master local search optimization to dominate your local market and attract customers in your area.',
      'blog.posts.localSEO.content': 'For service-based businesses, local SEO can be the difference between thriving and struggling. When potential customers search for services in your area, you want to be the first business they see...',
      'blog.posts.localSEO.tags': ['Local SEO', 'Digital Marketing', 'Local Business'],

      'blog.posts.designTrends2025.title': 'Design Trends That Will Dominate 2025',
      'blog.posts.designTrends2025.excerpt': 'Stay ahead of the curve with these emerging design trends that will shape the digital landscape in 2025.',
      'blog.posts.designTrends2025.content': 'The design world is constantly evolving, and staying current with trends is crucial for businesses that want to maintain a competitive edge...',
      'blog.posts.designTrends2025.tags': ['Design Trends', '2025', 'Web Design'],

      'blog.posts.contentMarketing.title': 'Building a Content Marketing Strategy That Converts',
      'blog.posts.contentMarketing.excerpt': 'Create compelling content that not only attracts your audience but also drives them to take action.',
      'blog.posts.contentMarketing.content': 'Content marketing is more than just creating blog posts. It\'s about developing a comprehensive strategy that educates, entertains, and converts your audience...',
      'blog.posts.contentMarketing.tags': ['Content Marketing', 'Strategy', 'Conversion'],

      'blog.posts.colorPsychology.title': 'The Psychology of Color in Brand Design',
      'blog.posts.colorPsychology.excerpt': 'Understand how color choices influence customer perception and decision-making in your brand design.',
      'blog.posts.colorPsychology.content': 'Colors have a profound impact on human psychology and can significantly influence how customers perceive and interact with your brand...',
      'blog.posts.colorPsychology.tags': ['Color Psychology', 'Brand Design', 'Visual Design'],

      // Individual Services
      'services.webdesign.title': 'Web Design & Development',
      'services.webdesign.description': 'Custom, responsive websites that are SEO-optimized, fast, and built for conversions.',
      'services.webdesign.features': ['Responsive Design', 'SEO Optimization', 'Performance Focused', 'Conversion Driven'],
      'services.webdesign.overview': 'We create stunning, high-performance websites that not only look great but also drive results. Our development process focuses on user experience, search engine optimization, and conversion optimization.',
      'services.webdesign.benefits': [
        'Mobile-first responsive design that works on all devices',
        'SEO-optimized code and content for better search rankings',
        'Fast loading times and optimized performance',
        'Conversion-focused design that turns visitors into customers',
        'Modern, clean code that\'s easy to maintain and update'
      ],
      'services.webdesign.process': [
        'Discovery & Planning',
        'Design & Wireframing', 
        'Development & Testing',
        'Launch & Optimization'
      ],
      'services.webdesign.technologies': ['React', 'Next.js', 'WordPress', 'Shopify', 'Custom PHP', 'Node.js'],

      'services.branding.title': 'Brand Identity & Logo Design',
      'services.branding.description': 'Logos, brand guidelines, and visual identity packages that make your business memorable.',
      'services.branding.features': ['Logo Design', 'Brand Guidelines', 'Visual Identity', 'Style Guides'],
      'services.branding.overview': 'Your brand is more than just a logo. We create comprehensive brand identity systems that communicate your values, differentiate you from competitors, and build trust with your audience.',
      'services.branding.benefits': [
        'Professional logo design that represents your brand values',
        'Comprehensive brand guidelines for consistent application',
        'Visual identity system including colors, typography, and imagery',
        'Style guides for all marketing materials',
        'Brand strategy that aligns with your business goals'
      ],
      'services.branding.process': [
        'Brand Research & Strategy',
        'Logo Design & Concepts',
        'Visual Identity Development',
        'Brand Guidelines Creation'
      ],
      'services.branding.deliverables': ['Primary & Secondary Logos', 'Brand Guidelines PDF', 'Color Palette', 'Typography System', 'Business Card Design', 'Social Media Templates'],

      'services.video.title': 'Video Production & Commercials',
      'services.video.description': 'Promo videos, YouTube content, drone footage, and business commercials that tell your story.',
      'services.video.features': ['Promo Videos', 'YouTube Content', 'Drone Footage', 'Business Commercials'],
      'services.video.overview': 'Video content is the most engaging form of media. We produce high-quality videos that capture attention, tell your story, and drive action from your audience.',
      'services.video.benefits': [
        'Professional video production for all platforms',
        'Engaging content that increases brand awareness',
        'Drone footage for unique aerial perspectives',
        'YouTube-optimized content for better reach',
        'Commercial-grade production quality'
      ],
      'services.video.process': [
        'Concept Development',
        'Scriptwriting & Storyboarding',
        'Filming & Production',
        'Editing & Post-Production'
      ],
      'services.video.services': ['Promotional Videos', 'Product Demos', 'Company Overviews', 'Testimonial Videos', 'Drone Photography', 'YouTube Content', 'Social Media Videos', 'TV Commercials'],

      'services.marketing.title': 'Digital Marketing & Strategy',
      'services.marketing.description': 'Social media strategy, ad-ready landing pages, local SEO, and online presence growth.',
      'services.marketing.features': ['Social Media Strategy', 'Landing Pages', 'Local SEO', 'Growth Marketing'],
      'services.marketing.overview': 'Strategic digital marketing that drives real business growth. We create data-driven campaigns that increase your online visibility, generate leads, and boost sales.',
      'services.marketing.benefits': [
        'Data-driven marketing strategies that deliver results',
        'Social media presence that engages your audience',
        'Local SEO to dominate your local market',
        'High-converting landing pages for campaigns',
        'Continuous optimization and growth tracking'
      ],
      'services.marketing.process': [
        'Market Research & Analysis',
        'Strategy Development',
        'Campaign Implementation',
        'Monitoring & Optimization'
      ],
      'services.marketing.services': ['Social Media Management', 'Google Ads & PPC', 'Facebook & Instagram Ads', 'Local SEO Optimization', 'Landing Page Design', 'Email Marketing', 'Content Marketing', 'Analytics & Reporting'],

      'services.automation.title': 'Business Automation',
      'services.automation.description': 'CRM setup, client onboarding forms, automated appointment booking, and chatbots.',
      'services.automation.features': ['CRM Setup', 'Client Onboarding', 'Appointment Booking', 'Chatbots'],
      'services.automation.overview': 'Automate your business processes to save time, reduce errors, and improve customer experience. We\'ll set up systems that work 24/7 to grow your business.',
      'services.automation.benefits': [
        'Automated customer relationship management',
        'Streamlined client onboarding process',
        '24/7 appointment booking system',
        'Intelligent chatbots for customer support',
        'Reduced manual work and human error'
      ],
      'services.automation.process': [
        'Process Analysis',
        'System Design',
        'Implementation & Testing',
        'Training & Launch'
      ],
      'services.automation.tools': ['HubSpot CRM', 'Zapier', 'Calendly', 'Intercom', 'Mailchimp', 'Slack', 'Trello', 'Asana'],

      'services.cybersecurity.title': 'Cybersecurity & Best Practices',
      'services.cybersecurity.description': 'Comprehensive security hardening, SSL setup, and secure data handling guidance.',
      'services.cybersecurity.features': ['Security Hardening', 'SSL Setup', 'Data Protection', 'Security Monitoring'],
      'services.cybersecurity.overview': 'Protect your business and customer data with enterprise-grade cybersecurity solutions. We implement industry best practices to secure your digital assets and maintain compliance.',
      'services.cybersecurity.benefits': [
        'Enhanced website security with industry best practices',
        'SSL certificate setup and domain management',
        'Secure data handling and privacy compliance',
        'Real-time security monitoring and threat detection',
        'Regular security audits and vulnerability assessments'
      ],
      'services.cybersecurity.process': [
        'Security Assessment',
        'Implementation & Hardening',
        'Monitoring Setup',
        'Ongoing Protection'
      ],
      'services.cybersecurity.services': [
        'Basic Site Security Hardening',
        'SSL Certificate Setup & Management',
        'Domain Security Configuration',
        'Secure Data Handling Guidelines',
        'Security Monitoring Integrations',
        'Vulnerability Assessments',
        'Security Policy Development',
        'Compliance Guidance'
      ],

      'services.maintenance.title': 'Maintenance & Ongoing Support',
      'services.maintenance.description': 'Comprehensive website maintenance, security monitoring, and ongoing support packages.',
      'services.maintenance.features': ['Website Updates', 'Security Monitoring', 'Performance Monitoring', 'Retainer Support'],
      'services.maintenance.overview': 'Keep your website running smoothly with our comprehensive maintenance and support services. We handle everything from regular updates to emergency fixes, so you can focus on your business.',
      'services.maintenance.benefits': [
        'Proactive website maintenance and updates',
        '24/7 security monitoring and threat response',
        'Performance optimization and speed monitoring',
        'Priority support and emergency bug fixes',
        'Flexible retainer options for ongoing support'
      ],
      'services.maintenance.process': [
        'Initial Assessment',
        'Maintenance Plan Setup',
        'Regular Monitoring & Updates',
        'Monthly Reporting & Optimization'
      ],
      'services.maintenance.services': [
        'Website Updates & Changes',
        'Security Monitoring & Threat Response',
        'Performance Monitoring & Optimization',
        'Bug Fixes & Technical Support',
        'Content Updates & Management',
        'Backup Management & Recovery',
        'Analytics Review & Reporting',
        'Retainer Options for Ongoing Support'
      ],

      // Maintenance Package Features
      'maintenance.basic.features': [
        'Up to 1 hour of updates/month (text changes, images, minor tweaks)',
        'Monthly security & performance check',
        'Basic plugin/theme updates',
        'Email support (48–72hr response)'
      ],
      'maintenance.standard.features': [
        'Up to 3 hours of updates/month',
        'Security scanning + performance optimization',
        'Minor design or content changes',
        'Analytics summary report',
        'Priority email support (24–48hr response)'
      ],
      'maintenance.premium.features': [
        'Up to 5–8 hours of updates/month',
        'Monthly analytics reports + recommendations',
        'Minor SEO improvements',
        'Proactive performance tweaks',
        'Priority support (same-day or next-day)',
        'Emergency fixes included (within reason)'
      ]
    }
  },
  es: {
    translation: {
      // Navigation
      'nav.home': 'Inicio',
      'nav.about': 'Acerca de',
      'nav.services': 'Servicios',
      'nav.work': 'Trabajos',
      'nav.process': 'Proceso',
      'nav.blog': 'Blog',
      'nav.startProject': 'Comenzar Proyecto',

      // Home Page
      'home.hero.title': 'Sitios Web que Realmente Convierten',
      'home.hero.subtitle': 'Deja de perder clientes por sitios web malos. Construyo sitios web personalizados y de alta conversión que convierten visitantes en clientes pagantes.',
      'home.hero.cta': 'Comenzar Proyecto Hoy',
      'home.hero.scroll': 'Desplázate para explorar',
      'home.hero.seeWork': 'Ver Servicios',
      'home.hero.stats.fastValue': 'Rápido',
      'home.hero.stats.fastLabel': 'Plazos de entrega',
      'home.hero.stats.affordableValue': 'Asequible',
      'home.hero.stats.affordableLabel': 'Precios',
      'home.hero.stats.satisfaction': 'Satisfacción del Cliente',

      'home.hero.eyebrow': 'El momento es ahora',

      // Services Overview
      'home.services.title': 'Lo que Ofrecemos',
      'home.services.subtitle': 'Rapidez, precios justos y un enfoque que se adapta a equipos de cualquier tamaño.',
      'home.services.highlights.quick.title': 'Entregas rápidas',
      'home.services.highlights.quick.description': 'Plazos claros y comunicación constante: tu sitio avanza según el calendario, sin meses de retraso.',
      'home.services.highlights.nofees.title': 'Sin cuotas mensuales',
      'home.services.highlights.nofees.description': 'Precios directos por proyecto, sin retenciones obligatorias: pagas el trabajo, no una suscripción interminable solo por estar en línea.',
      'home.services.highlights.scale.title': 'Para cualquier negocio: grande, pequeño o en etapa inicial',
      'home.services.highlights.scale.description': 'Desde founders que lanzan su primera idea hasta marcas establecidas, el proceso se ajusta a tus objetivos, presupuesto y ritmo.',
      'home.services.webdev.title': 'Diseño y Desarrollo de Sitios Web',
      'home.services.webdev.description': 'Sitios web personalizados enfocados en conversión que no solo se ven bien—generan resultados. Construidos para velocidad, SEO y tu rentabilidad.',
      'home.services.branding.title': 'Hosting',
      'home.services.branding.description': 'Hosting rápido, seguro y confiable en infraestructura cloud de nivel empresarial. SSL, copias de seguridad automáticas y 99.99% de uptime — gestionado por nosotros.',
      'home.services.video.title': 'Auditorías de Seguridad',
      'home.services.video.description': 'Revisiones integrales de seguridad de tu sitio web e infraestructura. Detectamos brechas, fortalecemos el stack y mantenemos tu negocio fuera de los titulares.',
      'home.services.marketing.title': 'SEO',
      'home.services.marketing.description': 'SEO técnico y on-page para que tu negocio sea encontrado. Velocidad, datos estructurados, estrategia de contenido y rankings medibles.',
      'home.services.content.title': 'Aplicaciones Móviles',
      'home.services.content.description': 'Apps nativas para iOS y Android construidas con React Native. Bonitas, rápidas y conectadas al mismo backend que tu sitio web.',
      'home.services.automation.title': 'Redes y Sistemas',
      'home.services.automation.description': 'Diseño y gestión de redes empresariales — Wi-Fi seguro, VPNs, firewalls y acceso remoto para oficinas, estudios y comercios.',
      
      // Why Choose Us
      'home.why.title': '¿Por qué Elegir FuturoCode Sobre las Agencias?',
      'home.why.attention.title': 'Atención Personalizada',
      'home.why.attention.description': 'Trabajas directamente conmigo, no con un diseñador junior o gerente de cuenta. Cada decisión se toma pensando en tus objetivos empresariales.',
      'home.why.price.title': 'Calidad de Agencia, Precio de Freelancer',
      'home.why.price.description': 'Obtén el mismo nivel de experiencia y atención al detalle que las mejores agencias, sin los costos generales y precios inflados.',
      'home.why.speed.title': 'Entrega Más Rápida',
      'home.why.speed.description': 'Sin trámites burocráticos, sin reuniones de comité, sin retrasos. Los proyectos avanzan rápidamente porque no hay burocracia que los ralentice.',
      'home.why.results.title': 'Enfoque Orientado a Resultados',
      'home.why.results.description': 'No solo construyo sitios web bonitos—construyo sitios web que convierten visitantes en clientes y hacen crecer tu negocio.',
      
      // Features
      'home.features.custom.title': 'Desarrollo Personalizado',
      'home.features.custom.description': 'Soluciones adaptadas que coinciden perfectamente con las necesidades de tu negocio e identidad de marca.',
      'home.features.mobile.title': 'Diseño Mobile-First',
      'home.features.mobile.description': 'Sitios web hermosos y responsivos que se ven y funcionan genial en cualquier dispositivo.',
      'home.features.performance.title': 'Optimizado para Rendimiento',
      'home.features.performance.description': 'Tiempos de carga ultrarrápidos y experiencias de usuario suaves que mantienen a los visitantes comprometidos.',
      
      // What I Do
      'home.whatido.title': 'Lo que Hago',
      'home.whatido.description': 'Diseño y construyo sitios web modernos y de alto rendimiento que no solo se ven bien — convierten visitantes en clientes pagantes. Ya sea que estés empezando desde cero o quieras actualizar un sitio obsoleto, trabajaré contigo uno a uno para crear algo que se ajuste a tus objetivos, marca y presupuesto.',
      'home.whatido.custom': 'Sitios web completamente personalizados (sin plantillas o diseños genéricos)',
      'home.whatido.fast': 'Carga rápida, optimizado para móviles y listo para SEO',
      'home.whatido.secure': 'Seguro, escalable y construido para crecer con tu negocio',
      'home.whatido.ux': 'Diseño UX limpio que guía a los visitantes a tomar acción',
      'home.whatido.goal': 'Cada sitio web que construyo tiene un objetivo claro: ayudarte a crecer — más tráfico, más confianza y más ingresos.',
      
      // Who I Help
      'home.whohelp.title': 'A Quién Ayudo',
      'home.whohelp.description': 'Trabajo con dueños de pequeñas empresas, proveedores de servicios locales y freelancers que están listos para tomar en serio su presencia en línea — sin pagar precios de agencia.',
      'home.whohelp.construction.title': 'Construcción y Paisajismo',
      'home.whohelp.construction.description': 'Contratistas de construcción, paisajismo y limpieza de terrenos que quieren mostrar su experiencia y atraer más clientes locales',
      'home.whohelp.services.title': 'Profesionales de Servicios Locales',
      'home.whohelp.services.description': 'Barberos, estilistas y profesionales de servicios locales que buscan construir su marca y atraer más clientes',
      'home.whohelp.creatives.title': 'Creativos y Freelancers',
      'home.whohelp.creatives.description': 'Fotógrafos, creativos y freelancers digitales que necesitan un portafolio que convierta visitantes en clientes',
      'home.whohelp.startups.title': 'Fundadores de Startups',
      'home.whohelp.startups.description': 'Fundadores de startups y nuevos emprendedores que necesitan una presencia profesional en línea para lanzar su negocio',
      'home.whohelp.business.title': 'Dueños de Negocios',
      'home.whohelp.business.description': 'Cualquiera que esté cansado de perder clientes por sitios web malos y quiera destacarse en su mercado',
      'home.whohelp.trades.title': 'Profesionales de Oficios',
      'home.whohelp.trades.description': 'Profesionales de oficios y trabajadores calificados que quieren mostrar su experiencia y atraer más clientes locales',
      'home.whohelp.cta': 'Si estás listo para destacarte en línea, estoy listo para construir algo poderoso para ti.',
      
      // Stats
      'home.stats.title': 'Por qué Importa tu Sitio Web',
      'home.stats.description': 'Una presencia en línea poderosa no es un lujo — es tu primera impresión. Estas estadísticas del mundo real muestran por qué tener un sitio web profesional y de alto rendimiento es más importante que nunca:',
      'home.stats.credibility.title': '75% de los usuarios juzgan la credibilidad de un negocio basándose en el diseño del sitio web',
      'home.stats.credibility.description': 'Un sitio web moderno y limpio no es solo agradable — es cómo la gente decide confiar en ti.',
      'home.stats.credibility.source': 'Fuente: Investigación de Credibilidad Web de Stanford',
      'home.stats.mobile.title': '60% de los usuarios no volverán a un sitio web que no sea amigable para móviles',
      'home.stats.mobile.description': 'Si tu sitio no se ve genial en móviles, estás perdiendo más de la mitad de tus clientes potenciales.',
      'home.stats.mobile.source': 'Fuente: Informe de UX Móvil de Google',
      'home.stats.growth.title': 'Las empresas con sitios web modernos crecen 2x más rápido',
      'home.stats.growth.description': 'Un buen sitio web no es un costo — es un motor de crecimiento.',
      'home.stats.growth.source': 'Fuente: Informe de Pequeñas Empresas de Deloitte',
      
      // Projects
      'home.projects.title': 'Últimos Proyectos',
      'home.projects.demo': 'Demo en Vivo',
      
      // Tech Stack
      'home.tech.title': 'Stack Tecnológico',
      
      // Testimonials
      'home.testimonials.title': 'Lo que Dicen Nuestros Clientes',
      'home.testimonials.subtitle':
        'Referencias directas de fundadores y operadores con los que trabajamos.',
      
      // Testimonial Content
      'testimonials.sarah.name': 'Sarah Johnson',
      'testimonials.sarah.role': 'Dueña de Empresa de Construcción',
      'testimonials.sarah.content': 'FuturoCode transformó nuestro sitio web obsoleto en una máquina generadora de leads. Hemos visto un aumento del 300% en consultas online desde el lanzamiento.',
      
      'testimonials.mike.name': 'Mike Chen',
      'testimonials.mike.role': 'Dueño de Restaurante Local',
      'testimonials.mike.content': 'El equipo de FuturoCode no solo construyó un sitio web—construyeron una experiencia digital que captura perfectamente nuestra marca. Nuestros pedidos online aumentaron un 150%.',
      
      'testimonials.lisa.name': 'Lisa Rodriguez',
      'testimonials.lisa.role': 'Estudio de Fotografía',
      'testimonials.lisa.content': 'Desde el concepto hasta el lanzamiento, el proceso fue fluido. Nuestro nuevo sitio web de portafolio nos ha ayudado a reservar más clientes de alto valor que nunca antes.',
      
      // Case Studies
      'home.casestudies.title': 'Resultados Reales, Clientes Reales',
      'home.casestudies.challenge': 'Desafío:',
      'home.casestudies.solution': 'Solución:',
      'home.casestudies.results': 'Resultados:',
      
      // Case Study Projects
      'casestudies.construction.title': 'Rediseño de Sitio Web de Empresa de Construcción',
      'casestudies.construction.challenge': 'Sitio web obsoleto perdiendo clientes potenciales ante la competencia',
      'casestudies.construction.solution': 'Diseño moderno mobile-first con formularios de captura de leads',
      'casestudies.construction.results': '300% de aumento en consultas online, 40% más llamadas telefónicas',
      
      'casestudies.restaurant.title': 'Sistema de Pedidos Online para Restaurante',
      'casestudies.restaurant.challenge': 'Sin presencia online, perdiendo clientes ante aplicaciones de delivery',
      'casestudies.restaurant.solution': 'Sitio web de pedidos personalizado con procesamiento de pagos integrado',
      'casestudies.restaurant.results': '150% de aumento en pedidos, 25% mayor valor promedio de pedido',
      
      'casestudies.photography.title': 'Lanzamiento de Portafolio de Fotografía',
      'casestudies.photography.challenge': 'Portafolio genérico que no convierte visitantes en clientes',
      'casestudies.photography.solution': 'Portafolio visual impresionante con integración de reservas',
      'casestudies.photography.results': '200% más consultas, 60% mayor tasa de reservas',
      
      // Contact
      'home.contact.title': 'Ponte en Contacto',
      'home.contact.headline': '¿Listo para cambiar tu vida para mejor?',
      'home.contact.description': 'Eleva tu estilo de vida elevando tu negocio.',
      'home.contact.button': 'Comenzar Proyecto',

      // Home — Pricing (bento section)
      'home.pricing.title': 'Planes pensados para tu crecimiento',
      'home.pricing.subtitle':
        'Calidad de agencia, precios cercanos al freelance.\nSin pagos recurrentes escondidos en contratos eternos — cancelas cuando quieras.',
      'home.pricing.growthBadge': 'Crecimiento',
      'home.pricing.recommendedLabel': 'El más recomendado',
      'home.pricing.featuredPrice': '$200',
      'home.pricing.featuredPriceSuffix': 'Tarifa plana (incluye rondas de revisión)',
      'home.pricing.featuredCta': 'Empezar',
      'home.pricing.launch.features': [
        'Sitio web de 1 página orientado a conversión',
        'Incluye rondas de revisión para adaptarlo a tus necesidades',
        'Hosting gratuito incluido—sin mensualidades (salvo si necesitas más ancho de banda: puedes subir a un plan de pago)',
        'Infra en Google Cloud para que cargue rápido y estable',
        'Ideal para startups, proyectos paralelos o quien necesita una presencia creíble de una página sin complicaciones.',
        'Enlaces a redes sociales incluidos',
      ],
      'home.pricing.scale.features': [
        'Páginas y revisiones ilimitadas',
        'Dominio personalizado',
        'Optimización SEO',
        'Soporte uno a uno',
      ],
      'home.pricing.enterprise.features': [
        'Estratega dedicado y hoja de ruta',
        'Lanzamientos de alto volumen e integraciones',
        'Opciones de soporte alineadas al SLA',
        'Escalamiento el mismo día disponible',
      ],
      'home.pricing.cards.starter.badge': 'Inicio',
      'home.pricing.cards.starter.priceLabel': '$150',
      'home.pricing.cards.starter.priceSuffix':
        'Tarifa plana (incluye rondas de revisión)',
      'home.pricing.cards.starter.cta': 'Iniciar proyecto',
      'home.pricing.cards.scale.badge': 'Escala',
      'home.pricing.cards.scale.priceLabel': '$5,000',
      'home.pricing.cards.scale.priceSuffix':
        'Tarifa plana (incluye rondas de revisión)',
      'home.pricing.cards.scale.cta': 'Hablemos',
      'home.pricing.cards.enterprise.badge': 'Empresa',
      'home.pricing.cards.enterprise.priceLabel': 'Desde $10,000 USD en adelante.',
      'home.pricing.cards.enterprise.cta': 'Contactar ventas',

      // Home — CTA marquee
      'home.ctaMarquee.title': 'Pensado para negocios en movimiento',
      'home.ctaMarquee.description':
        'Desde sitios de una página hasta sistemas de marca completos — trabajo de calidad de agencia con la agilidad de un freelancer. Construyamos algo que convierta.',
      'home.ctaMarquee.primaryButton': 'INICIAR PROYECTO',
      'home.ctaMarquee.secondaryButton': 'NUESTROS SERVICIOS',
      'home.ctaMarquee.items': [
        'Fundadores y startups',
        'Restaurantes y cafés',
        'Construcción y oficios',
        'Fotógrafos y creativos',
        'Servicios profesionales locales',
        'Marcas de comercio electrónico',
      ],

      // Home — Uptime / infrastructure
      'home.uptime.badge': 'Todo operativo',
      'home.uptime.title': 'Siempre en línea. Pensado para no caer.',
      'home.uptime.subtitle':
        'Tu sitio corre en proveedores cloud de nivel empresarial y, cuando hace falta, lo replicamos en infraestructura propia autoservicio. Si uno falla, el sitio sigue arriba.',
      'home.uptime.stats': [
        {
          value: '99.9%',
          label: 'Tiempo activo objetivo',
          description:
            'Supervisado en cada proyecto que entregamos y mantenemos.',
        },
        {
          value: '24/7',
          label: 'Monitoreo',
          description:
            'Alertas automáticas ante picos de latencia o errores.',
        },
        {
          value: '<1m',
          label: 'Conmutación (failover)',
          description:
            'Recuperación automática ante caídas, con fallback estático en caché.',
        },
      ],
      'home.uptime.multiCloud.title': 'Multi-nube + respaldo autoservidor',
      'home.uptime.multiCloud.subtitle':
        'Tu sitio no depende de un único punto de fallo.',
      'home.uptime.hostedOn': 'Alojado en',
      'home.uptime.selfHostedLabel': 'Infra propia',

      // Home — Security strip
      'home.security.heroBadge': 'Seguridad y confianza',
      'home.security.title':
        'La seguridad no es un «extra».\nEs la base.',
      'home.security.subtitle':
        'Cada sitio que lanzamos lleva controles de primer nivel — confianza cero, criptografía actual, monitorización continua y un canal de entrega endurecido. Pensado para que tu negocio no salga en titulares por un incidente.',
      'home.security.metrics': [
        { label: 'SLA de disponibilidad', value: '99.99%' },
        { label: 'Cifrado', value: 'AES-256' },
        { label: 'TLS', value: '1.3' },
        { label: 'Tiempo medio de detección', value: '< 60 s' },
      ],
      'home.security.pillars': [
        {
          title: 'Arquitectura zero trust',
          description:
            'Cada solicitud y sesión verificadas de forma continua. Proxies conscientes de la identidad y acceso de mínimo privilegio por defecto.',
        },
        {
          title: 'Cifrado de extremo a extremo',
          description:
            'TLS 1.3 en tránsito y AES-256 en reposo. HSTS, secreto hacia adelante perfecto y conjuntos de cifrado modernos en todas partes.',
        },
        {
          title: 'Infraestructura endurecida',
          description:
            'Despliegues inmutables, artefactos firmados, tiempos de ejecución aislados y parches automatizados. Sobre fundamentos cloud de nivel empresarial.',
        },
        {
          title: 'Protección DDoS y WAF',
          description:
            'Filtrado en el borde anycast, mitigación de bots, límites de tasa y un firewall web (WAF) afinado a OWASP frente a cada sitio.',
        },
        {
          title: 'Monitorización continua',
          description:
            'Inteligencia de amenazas en tiempo real, detección de anomalías, correlación en SIEM y alertas 24/7 ante actividad sospechosa.',
        },
        {
          title: 'Secretos y gestión de llaves',
          description:
            'Cajas de llaves respaldadas en hardware, credenciales de corta duración, rotación automática y cero secretos en texto plano en código o CI.',
        },
        {
          title: 'Identidad y MFA',
          description:
            'SSO, passkeys, WebAuthn y MFA adaptativo. Autenticación resistente a phishing para admins y clientes.',
        },
        {
          title: 'SDLC seguro',
          description:
            'SAST, DAST, escaneo de dependencias, commits firmados y políticas como código en cada pull request.',
        },
        {
          title: 'Privacidad por diseño',
          description:
            'Flujos alineados a GDPR y CCPA, gestión de consentimiento, residencia regional y recolección mínima por defecto.',
        },
      ],
      'home.security.standardsTitle':
        'Alineados con estándares que piden tus compradores',
      'home.security.standardsSubtitle':
        'Prácticas de ingeniería mapeadas a marcos que importan en compras empresariales.',
      'home.security.standards': [
        'Alineado a SOC 2 Tipo II',
        'Alineado a ISO 27001',
        'Preparado para GDPR',
        'Preparado para CCPA',
        'Preparado para HIPAA',
        'Referencia PCI DSS',
        'OWASP ASVS',
        'NIST CSF',
      ],
      'home.security.footerHint':
        '¿Quieres profundizar? Pídenos nuestra guía corta de seguridad y modelo de amenazas.',

      // About Page
      'about.hero.title': 'Acerca de Mí',
      'about.hero.subtitle': 'Construyendo historias de éxito digital, un negocio a la vez',
      'about.intro.title': 'Me enfoco en ver ganar a las pequeñas empresas',
      'about.intro.lead': 'Porque cada victoria tuya es una victoria mía. Tu éxito impulsa todo lo que hago.',
      'about.intro.paragraph1': 'En FuturoCode, no solo construyo sitios web o ejecuto campañas de marketing. Construyo motores de crecimiento adaptados a tus objetivos empresariales. Combino diseño limpio y de vanguardia con estrategias tecnológicas y de marketing inteligentes que obtienen resultados reales.',
      'about.intro.paragraph2': 'Entiendo los desafíos de competir en el mundo digital de hoy. Por eso me enfoco en comunicación clara, soluciones personalizadas y una mentalidad de asociación. Tu negocio merece más que un sitio web genérico — merece una presencia digital que realmente convierta visitantes en clientes.',
      'about.intro.paragraph3': 'Cuando trabajas conmigo, obtienes un desarrollador y estratega que está invertido en tu éxito. Tu crecimiento es mi misión, y juntos construiremos una marca y plataforma que se destaque, gane confianza e impulse ingresos.',
      'about.intro.closing': 'Hagamos de tu negocio la próxima gran historia de éxito.',
      'about.values.title': 'Lo que me Impulsa',
      'about.highlights.title': 'Por qué Elegir FuturoCode',
      'about.cta.title': '¿Listo para construir tu historia de éxito?',
      'about.cta.subtitle': 'Creemos algo increíble juntos',
      'about.cta.button': 'Comenzar Proyecto',
      'about.cta.headline': '¿Listo para cambiar tu vida para mejor?',
      'about.intro.minimal.headline': 'CERTEZA',
      'about.intro.minimal.line1': 'Tranquilo: sabrás que estás en buenas manos,',
      'about.intro.minimal.line2':
        'para que puedas enfocarte en lo que importa.',
      'about.marquee.stats': [
        '100 % hecho a medida',
        'Soporte 24/7',
        'Carga <2 s',
        '∞ Iteraciones',
      ],
      'about.aria.statsMarquee': 'Cifras clave',
      'about.aria.highlightsScene': 'Por qué elegir FuturoCode',
      'about.spatial.pillarWord': 'Pilar',
      'about.spatial.left.label': 'Diseño',
      'about.spatial.left.title': 'Hecho para convertir',
      'about.spatial.left.description':
        'Interfaces pixel-perfect pensadas para convertir visitantes en clientes. Identidad de marca, motion y UX que se siente inevitable.',
      'about.spatial.left.status': 'Activo',
      'about.spatial.left.meta': '+50 piezas entregadas',
      'about.spatial.left.featureBrand': 'Fidelidad de marca',
      'about.spatial.left.featureIterate': 'Velocidad de iteración',
      'about.spatial.right.label': 'Código',
      'about.spatial.right.title': 'Construido para durar',
      'about.spatial.right.description':
        'Bases de código modernas y rápidas, desplegadas con cuidado. Carga bajo dos segundos, analítica en tiempo real y lanzamientos sin caídas.',
      'about.spatial.right.status': 'En línea',
      'about.spatial.right.meta': '+200 despliegues',
      'about.spatial.right.featurePerf': 'Rendimiento',
      'about.spatial.right.featureUptime': 'Disponibilidad',

      // Values
      'values.growth.title': 'Enfocado en el Crecimiento',
      'values.growth.description': 'Cada solución está diseñada para impulsar el crecimiento empresarial real y resultados medibles.',
      'values.custom.title': 'Soluciones Personalizadas',
      'values.custom.description': 'No enfoques genéricos. Cada proyecto está adaptado a tus necesidades empresariales únicas.',
      'values.results.title': 'Orientado a Resultados',
      'values.results.description': 'Nos enfocamos en estrategias y diseños que convierten visitantes en clientes leales.',
      'values.partnership.title': 'Mentalidad de Asociación',
      'values.partnership.description': 'Tu éxito es nuestro éxito. Estamos invertidos en tu crecimiento a largo plazo.',

      // Highlights
      'highlights.strategy.title': 'Estrategia Inteligente',
      'highlights.strategy.description': 'Combinando diseño de vanguardia con estrategias de marketing inteligentes',
      'highlights.communication.title': 'Comunicación Clara',
      'highlights.communication.description': 'Procesos transparentes y actualizaciones regulares durante tu proyecto',
      'highlights.results.title': 'Resultados Comprobados',
      'highlights.results.description': 'Historial de ayudar a las empresas a destacarse e impulsar ingresos',

      // Services Page
      'services.hero.title': 'Nuestros Servicios',
      'services.hero.subtitle': 'Soluciones digitales integrales para hacer crecer tu negocio y establecer una presencia online poderosa',
      'services.hero.badge': 'Soluciones integrales',
      'services.hero.viewAll': 'Ver todos los servicios',
      'services.offeringGrid.title': 'Velocidad. Seguridad. Escala.',
      'services.offeringGrid.subtitle':
        'Servicios integrales con el rendimiento y la fiabilidad que tu negocio merece.',
      'services.detailCard.startingLabel': 'Desde',
      'services.detailCard.priceCustom': 'Presupuesto a medida',
      'services.detailCard.bookCall': 'Reservar llamada',
      'services.cta.title': 'Construyamos tu próxima gran cosa',
      'services.cta.subtitle': '¿Listo para transformar tu negocio con soluciones digitales profesionales?',
      'services.cta.button': 'Comenzar Proyecto',

      // Services page — offerings grid (titles/descriptions: home.services.*)
      'services.offerings.webdev.tags': ['Construcción personalizada', 'Velocidad y UX', 'Listo para SEO', 'Conversiones'],
      'services.offerings.webdev.overview': 'Sitios web personalizados enfocados en conversión que no solo se ven bien—generan resultados. Construidos para velocidad, SEO y tu rentabilidad.',
      'services.offerings.webdev.benefits': [
        'Experiencias rápidas y accesibles que reducen el rebote',
        'UX e IA centrados en tus recorridos de cliente reales',
        'SEO técnico integrado—no pegado al final',
        'Stacks flexibles para no quedar atrapado en plantillas obsoletas'
      ],
      'services.offerings.webdev.process': [
        'Descubrimiento — objetivos, audiencia, límites, competencia',
        'Diseño y prototipos — maquetación, tipografía, UX mobile-first',
        'Construcción e integraciones — CMS, APIs, analíticas, formularios',
        'QA, lanzamiento y handoff — rendimiento, redirecciones, documentación'
      ],
      'services.offerings.webdev.technologies': ['React', 'JavaScript', 'Tailwind/CSS', 'Headless/CMS', 'Listo para cloud'],

      'services.offerings.hosting.tags': ['SSL/TLS', 'Copias de seguridad', 'Uptime', 'Nube'],
      'services.offerings.hosting.overview': 'Hosting rápido, seguro y confiable en infraestructura cloud de nivel empresarial. SSL, copias automáticas y 99.99% de uptime—gestionado por nosotros.',
      'services.offerings.hosting.benefits': [
        'Certificados y defaults de seguridad razonables',
        'Copias automáticas para que la recuperación no sea crisis',
        'Monitorización realista—not solo marketing',
        'Menos tiempo con DNS/servidores, más tiempo en tu negocio'
      ],
      'services.offerings.hosting.process': [
        'Dimensionado — tráfico, geografía, compliance',
        'Aprovisionamiento y migración — DNS, redirecciones, HTTPS',
        'Fortalecer — firewall, mínimos privilegios, parches',
        'Observar — verificación de uptime, backups, alertas'
      ],
      'services.offerings.hosting.technologies': ['TLS/SSL', 'CDN', 'Almacenamiento', 'BD gestionada'],

      'services.offerings.security.tags': ['Evaluaciones', 'Endurecimiento', 'Enfoque compliance', 'Arreglos accionables'],
      'services.offerings.security.overview': 'Revisiones integrales de seguridad de tu sitio e infraestructura. Detectamos brechas, fortalecemos el stack y te alejamos de titulares negativos.',
      'services.offerings.security.benefits': [
        'Modelado de amenazas adaptado al riesgo de pymes—no checklist genéricos',
        'Severidades claras para invertir donde importa más',
        'Guías de remedio en hosting, CMS y plugins',
        'Menos suposiciones: qué está roto, por qué y cómo arreglarlo'
      ],
      'services.offerings.security.process': [
        'Alcance — activos, integraciones, flujos, reguladores',
        'Evaluación — TLS, sesiones, subidas, IAM, backups',
        'Informe — issues priorizados con pruebas reproducibles',
        'Remediar y verificar — endurecer stack, regresiones'
      ],
      'services.offerings.security.technologies': ['OWASP', 'Endurecimiento TLS', 'Headers/CSP', 'Logs'],

      'services.offerings.seo.tags': ['SEO técnico', 'Datos estructurados', 'Contenido', 'Mediciones'],
      'services.offerings.seo.overview': 'SEO técnico y on-page para que tu negocio sea encontrado. Rendimiento en página, datos estructurados, estrategia de contenido y rankings medibles.',
      'services.offerings.seo.benefits': [
        'Bases rastreables e indexables que se acumulan con el tiempo',
        'Meta y schema afinados a intención',
        'Flujos editoriales desde tu conocimiento hasta páginas buscables',
        'Instrumentación que conecta mejoras con conversiones'
      ],
      'services.offerings.seo.process': [
        'Auditoría base — crawling, benchmarks SERP',
        'Ganancias rápidas vs hoja de ruta',
        'Implementar — redirects, enlaces internos, snippets UX',
        'Medir — Search Console, KPIs y ajustes iterativos'
      ],
      'services.offerings.seo.technologies': ['Search Console/Webmaster', 'JSON-LD', 'Core Web Vitals', 'Eventos GA'],

      'services.offerings.mobile.tags': ['React Native', 'iOS/Android', 'APIs', 'Entrega ágil'],
      'services.offerings.mobile.overview': 'Apps para iOS y Android construidas con React Native que se sienten nativas. Rápidas y con el mismo backend que tu web.',
      'services.offerings.mobile.benefits': [
        'Lógica compartida acorta plazos y reduce divergencia',
        'Navegación y gestos familiares en cada sistema',
        'Integración segura igual que tus productos web',
        'Ciclos de release iterativos'
      ],
      'services.offerings.mobile.process': [
        'Definición — personas, onboarding, offline si aplica',
        'UX/UI — sistema que une web y móvil',
        'Ingeniería — RN, contratos API, QA por dispositivo',
        'Release — betas internas, despliegue, telemetría'
      ],
      'services.offerings.mobile.technologies': ['React Native', 'JavaScript/TypeScript', 'REST/GraphQL', 'Notificaciones push'],

      // Service Packages
      'packages.starter.title': '🚀 Paquete de Sitio Web Básico',
      'packages.starter.description': 'Perfecto para pequeñas empresas y startups que buscan establecer su presencia online',
      'packages.starter.budget': '$500 – $800',
      'packages.starter.features': [
        'Sitio web personalizado de 1-3 páginas',
        'Diseño mobile-first',
        'Configuración básica de SEO',
        'Formulario de contacto',
        'Selección simple de colores de marca y tipografía'
      ],

      'packages.business.title': '💼 Paquete de Crecimiento Empresarial',
      'packages.business.description': 'Solución integral para empresas establecidas listas para escalar su presencia online',
      'packages.business.budget': '$1,500 – $2,500',
      'packages.business.features': [
        'Sitio web personalizado de 5-10 páginas',
        'Paquete de branding (logo, paleta de colores, tipografía)',
        'Optimización SEO',
        'Fotografía profesional o imágenes de stock de calidad',
        'Configuración de Google Analytics y Search Console',
        'Sección de blog',
        'Integración básica de video (ej. video de fondo en hero)'
      ],

      'packages.creative.title': '🎥 Paquete de Medios Creativos y Marketing',
      'packages.creative.description': 'Contenido de video profesional y activos de redes sociales para impulsar la presencia visual de tu marca',
      'packages.creative.budget': '$1,200 – $2,000',
      'packages.creative.features': [
        'Comercial de video empresarial de 60 segundos',
        'Imágenes de dron (cuando esté disponible)',
        'Clips de contenido para redes sociales',
        'Visuales de marca personalizados para redes sociales',
        'Complemento opcional de escritura de blog'
      ],

      'packages.full.title': '🧩 Paquete de Solución Digital Completa',
      'packages.full.description': 'Transformación digital completa para empresas establecidas listas para dominar su mercado',
      'packages.full.budget': '$5,000 – $7,000',
      'packages.full.features': [
        'Sitio web completamente personalizado',
        'Animaciones avanzadas, UI interactiva',
        'Paquete de branding completo',
        'Estrategia de marketing digital',
        'Creación de contenido (foto/video)',
        'Flujos de trabajo de automatización empresarial (próximamente)',
        'Mantenimiento continuo e informes de análisis',
        'Mejores prácticas de ciberseguridad'
      ],

      // Digital Marketing
      'digital.title': '🚀 Gestión de Marketing Digital y Anuncios',
      'digital.description': 'Haz crecer tu negocio con marketing digital estratégico y anuncios pagados diseñados para llegar a la audiencia correcta y generar resultados reales. Perfecto para pequeñas empresas que buscan aumentar la visibilidad sin desperdiciar presupuesto publicitario.',
      'digital.services.title': 'Servicios Incluidos:',
      'digital.services.list': [
        'Anuncios de Facebook e Instagram',
        'Anuncios de búsqueda y display de Google',
        'Investigación y segmentación de audiencia',
        'Creativos publicitarios personalizados (imágenes y texto)',
        'Seguimiento de conversiones e informes de análisis',
        'Optimización continua de campañas',
        'Informes mensuales claros para que siempre sepas dónde va tu dinero'
      ],
      'digital.package.title': '💡 Paquete Básico',
      'digital.package.description': 'Perfecto para pequeñas empresas que buscan generar leads, ventas y conciencia de marca sin romper el banco.',
      'digital.pricing.setup': 'Tarifa de configuración única:',
      'digital.pricing.setup.amount': '$500',
      'digital.pricing.monthly': 'Gestión mensual:',
      'digital.pricing.monthly.amount': '$300 - $500/mes',
      'digital.pricing.budget': 'Presupuesto publicitario recomendado:',
      'digital.pricing.budget.amount': '$500–$1,500/mes',
      'digital.pricing.note': '(pagado directamente a las plataformas publicitarias)',
      'digital.included.title': 'Lo que está Incluido:',
      'digital.included.list': [
        'Investigación del negocio del cliente y competidores',
        'Configuración de cuentas publicitarias (Facebook Business Manager, Google Ads)',
        'Escritura de texto publicitario y diseño de creativos',
        'Creación de campañas, conjuntos de anuncios y audiencias',
        'Monitoreo y ajuste de campañas al menos semanalmente',
        'Análisis de resultados y preparación de informes',
        'Comunicación regular con el cliente'
      ],
      'digital.communication.title': 'Comunicación:',
      'digital.communication.list': [
        'Llamadas semanales o quincenales',
        'Respuestas rápidas a preguntas'
      ],
      'digital.cta.button': 'Comenzar con Marketing Digital',

      // Maintenance
      'maintenance.title': 'Retenedor de Mantenimiento y Soporte',
      'maintenance.description': 'Ediciones y actualizaciones mensuales del sitio • Verificaciones de seguridad y rendimiento • Cambios de contenido • Soporte prioritario',
      'maintenance.subtitle': 'Tranquilidad para empresas ocupadas después del lanzamiento.',
      'maintenance.basic.title': '⭐ Mantenimiento Básico',
      'maintenance.basic.price': '$50–$100/mes',
      'maintenance.basic.description': '→ Perfecto para pequeñas empresas con sitios simples que raramente necesitan cambios.',
      'maintenance.standard.title': '🚀 Mantenimiento Estándar',
      'maintenance.standard.price': '$150–$300/mes',
      'maintenance.standard.description': '→ Buen punto medio para empresas que actualizan contenido regularmente o quieren tranquilidad.',
      'maintenance.premium.title': '💼 Mantenimiento Premium',
      'maintenance.premium.price': '$400–$700+/mes',
      'maintenance.premium.description': '→ Para empresas que ejecutan sitios más complejos o que quieren servicios "de guardia" y primera prioridad.',
      'maintenance.cta.button': 'Comenzar con Mantenimiento',

      // Common
      'common.getStarted': 'Comenzar',
      'common.budget': 'Presupuesto',
      'common.clickForDetails': 'Haz clic para detalles',
      'common.overview': 'Resumen',
      'common.benefits': 'Beneficios Clave',
      'common.process': 'Nuestro Proceso',
      'common.technologies': 'Tecnologías que Usamos',
      'common.deliverables': 'Lo que Recibirás',
      'common.services': 'Servicios Incluidos',
      'common.tools': 'Herramientas y Plataformas',
      'common.comingSoon': 'Próximamente',
      'common.with': 'con',

      // Work Page
      'work.hero.title': 'Nuestros Trabajos',
      'work.hero.subtitle': 'Mostrando nuestros últimos proyectos y soluciones creativas que generan resultados',
      'work.cta.title': '¿Te gusta lo que ves?',
      'work.cta.subtitle': 'Creemos algo increíble juntos',
      'work.cta.button': 'Comenzar Proyecto',

      // Work Categories
      'work.categories.all': 'Todos los Proyectos',
      'work.categories.web': 'Diseño y Desarrollo Web',
      'work.categories.branding': 'Logos y Branding',
      'work.categories.video': 'Video y Trabajo Comercial',
      'work.categories.experiments': 'Experimentos Creativos',

      // Work Common
      'work.featured': 'Destacado',
      'work.comingSoon': 'Próximamente',
      'work.viewDemo': 'Ver Demo',
      'work.clickForDetails': 'Haz clic para detalles',
      'work.viewLiveDemo': 'Ver Demo en Vivo',
      'work.startSimilarProject': 'Comenzar Proyecto Similar',

      // Work Modal
      'work.modal.overview': 'Resumen',
      'work.modal.challenge': 'El Desafío',
      'work.modal.solution': 'Nuestra Solución',
      'work.modal.features': 'Características Clave',
      'work.modal.process': 'Nuestro Proceso',
      'work.modal.technologies': 'Tecnologías Utilizadas',
      'work.modal.deliverables': 'Entregables',
      'work.modal.services': 'Servicios Incluidos',
      'work.modal.results': 'Resultados e Impacto',
      'work.modal.applications': 'Aplicaciones',

      // Individual Projects
      'projects.siteclearing.title': 'Sitio Web de Limpieza y Demolición',
      'projects.siteclearing.description': 'Un sitio web profesional para una empresa de limpieza y demolición de terrenos, con exhibición de servicios y formularios de contacto.',
      'projects.siteclearing.overview': 'Un sitio web integral para una empresa de limpieza y demolición de terrenos que muestra sus servicios, experiencia y facilita que los clientes potenciales se pongan en contacto. El sitio presenta un diseño moderno con descripciones claras de servicios, galerías de proyectos y múltiples opciones de contacto.',
      'projects.siteclearing.challenge': 'Crear una presencia online profesional para una empresa de construcción que genere confianza y leads en una industria competitiva.',
      'projects.siteclearing.solution': 'Desarrollamos un sitio web responsivo con ofertas de servicios claras, exhibición de proyectos, testimonios de clientes y múltiples puntos de captura de leads incluyendo formularios de contacto e integración telefónica.',
      'projects.siteclearing.features': [
        'Diseño responsivo que funciona en todos los dispositivos',
        'Exhibición de servicios con descripciones detalladas',
        'Galería de proyectos con imágenes antes/después',
        'Testimonios y reseñas de clientes',
        'Formularios de contacto e integración telefónica',
        'Optimización SEO para búsqueda local',
        'Tiempos de carga rápidos y optimización de rendimiento'
      ],
      'projects.siteclearing.process': [
        'Consulta con el cliente y recopilación de requisitos',
        'Maquetas de diseño y wireframing',
        'Desarrollo y creación de contenido',
        'Pruebas y optimización',
        'Lanzamiento y soporte post-lanzamiento'
      ],
      'projects.siteclearing.results': [
        'Aumento del 150% en consultas online',
        'Mejores rankings en búsqueda local',
        'Credibilidad profesional mejorada',
        'Proceso de generación de leads optimizado'
      ],
      'projects.siteclearing.client': 'Empresa de Limpieza y Demolición',
      'projects.siteclearing.duration': '4 semanas',
      'projects.siteclearing.team': '2 desarrolladores, 1 diseñador',

      'projects.barber.title': 'Demo de Reserva de Barbería',
      'projects.barber.description': 'Un sistema de reserva interactivo para barberías con programación de citas y gestión de clientes.',
      'projects.barber.overview': 'Un sistema de reserva integral diseñado específicamente para barberías y salones de belleza. La plataforma permite a los clientes reservar citas online, gestionar sus perfiles y proporciona a los barberos herramientas para gestionar su horario y base de clientes.',
      'projects.barber.challenge': 'Crear un sistema de reserva intuitivo que reduzca las ausencias y optimice el proceso de citas tanto para clientes como para barberos.',
      'projects.barber.solution': 'Desarrollamos una aplicación full-stack con disponibilidad en tiempo real, recordatorios automatizados y una interfaz fácil de usar tanto para clientes como para proveedores de servicios.',
      'projects.barber.features': [
        'Sistema de reserva de citas en tiempo real',
        'Gestión de perfiles de clientes',
        'Gestión de horarios de barberos',
        'Recordatorios automatizados de citas',
        'Integración de procesamiento de pagos',
        'Sistema de reseñas y calificaciones',
        'Diseño responsivo para móviles'
      ],
      'projects.barber.process': [
        'Investigación de mercado y entrevistas con usuarios',
        'Diseño UI/UX y prototipado',
        'Desarrollo full-stack',
        'Pruebas y retroalimentación de usuarios',
        'Lanzamiento y optimización'
      ],
      'projects.barber.technologies': ['Frontend React', 'Backend Node.js', 'Base de Datos MongoDB', 'Pagos Stripe', 'SMS Twilio', 'AWS Hosting'],

      'projects.realestate.title': 'Demo de Página de Aterrizaje de Bienes Raíces',
      'projects.realestate.description': 'Una página de aterrizaje de alta conversión para agentes inmobiliarios con exhibición de propiedades y formularios de captura de leads.',
      'projects.realestate.overview': 'Una página de aterrizaje enfocada en conversión diseñada específicamente para agentes inmobiliarios para mostrar propiedades y capturar leads calificados. La página presenta galerías de propiedades, tours virtuales y múltiples puntos de captura de leads optimizados para ventas inmobiliarias.',
      'projects.realestate.challenge': 'Crear una página de aterrizaje que convierta espectadores de propiedades en leads calificados mientras muestra las propiedades efectivamente.',
      'projects.realestate.solution': 'Desarrollamos una página de aterrizaje de alta conversión con exhibición de propiedades, tours virtuales, imanes de leads y colocación estratégica de llamadas a la acción.',
      'projects.realestate.features': [
        'Exhibición de propiedades con galerías de imágenes',
        'Integración de tours virtuales',
        'Formularios de captura de leads y popups',
        'Búsqueda y filtrado de propiedades',
        'Perfil del agente e información de contacto',
        'Testimonios y prueba social',
        'Diseño optimizado para móviles'
      ],
      'projects.realestate.process': [
        'Investigación y análisis de conversión',
        'Diseño de página de aterrizaje y copywriting',
        'Desarrollo e integración',
        'Pruebas A/B y optimización',
        'Lanzamiento y monitoreo de rendimiento'
      ],
      'projects.realestate.technologies': ['React con TypeScript', 'Backend Firebase', 'API de Google Maps', 'Integración Stripe', 'Seguimiento de Analytics'],

      'projects.futurocode.title': 'Identidad de Marca FuturoCode',
      'projects.futurocode.description': 'Paquete completo de identidad de marca incluyendo diseño de logo, paleta de colores y guías de marca.',
      'projects.futurocode.overview': 'Un sistema integral de identidad de marca para FuturoCode, estableciendo una presencia visual profesional y moderna en la industria de servicios digitales. La identidad de marca refleja innovación, confiabilidad y un enfoque visionario.',
      'projects.futurocode.challenge': 'Crear una identidad de marca distintiva que posicione a FuturoCode como un proveedor líder de servicios digitales mientras mantiene profesionalismo y accesibilidad.',
      'projects.futurocode.solution': 'Desarrollamos un sistema de marca completo incluyendo logos primarios y secundarios, paleta de colores, tipografía y guías de marca integrales para aplicación consistente.',
      'projects.futurocode.features': [
        'Diseños de logos primarios y secundarios',
        'Paleta de colores integral',
        'Sistema de tipografía y jerarquía',
        'Guías de marca y guía de estilo',
        'Diseño de tarjetas de negocio y papelería',
        'Plantillas para redes sociales',
        'Ejemplos de aplicación de marca'
      ],
      'projects.futurocode.process': [
        'Investigación y posicionamiento de marca',
        'Desarrollo de conceptos de logo',
        'Creación de identidad visual',
        'Documentación de guías de marca',
        'Implementación y capacitación'
      ],
      'projects.futurocode.deliverables': [
        'Logo Primario (Color Completo)',
        'Secondary Logo (Monochrome)',
        'Brand Guidelines PDF',
        'Color Palette (RGB, CMYK, HEX)',
        'Typography System',
        'Business Card Design',
        'Social Media Templates',
        'Brand Style Guide'
      ],
      'projects.futurocode.results': [
        'Established professional brand presence',
        'Consistent visual communication',
        'Enhanced brand recognition',
        'Improved client trust and credibility'
      ],

      'projects.restaurant.title': 'Colección de Logos de Restaurantes',
      'projects.restaurant.description': 'A collection of modern logo designs for various restaurant concepts and food brands.',
      'projects.restaurant.overview': 'A diverse collection of restaurant and food brand logos showcasing different styles, from elegant fine dining to casual eateries. Each logo is designed to reflect the unique personality and cuisine of the establishment.',
      'projects.restaurant.challenge': 'Create distinctive logos that capture the essence of different restaurant concepts while maintaining visual appeal and brand recognition.',
      'projects.restaurant.solution': 'Developed a range of logo styles using various design techniques, color palettes, and typography to suit different restaurant types and target audiences.',
      'projects.restaurant.features': [
        'Multiple logo design styles',
        'Custom typography and lettering',
        'Strategic color palette selection',
        'Scalable vector designs',
        'Brand personality alignment',
        'Industry-specific design elements',
        'Versatile application formats'
      ],
      'projects.restaurant.process': [
        'Concept research and mood boards',
        'Sketching and concept development',
        'Digital design and refinement',
        'Color and typography selection',
        'Finalization and file preparation'
      ],
      'projects.restaurant.styles': ['Modern Minimalist', 'Vintage Retro', 'Elegant Fine Dining', 'Casual Contemporary', 'Artisan Craft', 'International Cuisine'],
      'projects.restaurant.deliverables': [
        'Primary Logo Design',
        'Secondary Logo Variations',
        'Color Palette',
        'Typography Recommendations',
        'Usage Guidelines',
        'Digital and Print Files'
      ],

      'projects.commercial.title': 'Product Commercial Demo',
      'projects.commercial.description': 'Professional product commercials and promotional videos for e-commerce and retail brands.',
      'projects.commercial.overview': 'High-quality product commercials and promotional videos designed to showcase products effectively and drive sales. Our video production services include concept development, filming, editing, and post-production effects.',
      'projects.commercial.challenge': 'Create compelling video content that highlights product features, builds brand awareness, and drives customer engagement and sales.',
      'projects.commercial.solution': 'Developed comprehensive video production services with professional equipment, creative storytelling, and advanced post-production techniques to create impactful commercial content.',
      'projects.commercial.features': [
        'Product showcase and demonstration',
        'Brand storytelling and messaging',
        'Professional lighting and cinematography',
        'Motion graphics and visual effects',
        'Multiple video formats and lengths',
        'Social media optimization',
        'Analytics and performance tracking'
      ],
      'projects.commercial.process': [
        'Desarrollo de conceptos y storyboarding',
        'Planificación de pre-producción',
        'Filmación y producción',
        'Post-producción y edición',
        'Revisión del cliente y revisiones',
        'Entrega final y optimización'
      ],
      'projects.commercial.services': [
        'Product Commercials (30s, 60s)',
        'Social Media Videos (15s, 30s)',
        'Product Demonstrations',
        'Brand Story Videos',
        'Testimonial Videos',
        'Behind-the-Scenes Content'
      ],
      'projects.commercial.equipment': ['4K Camera Systems', 'Professional Lighting', 'Drone Footage', 'Motion Graphics', 'Color Grading', 'Audio Enhancement'],

      'projects.drone.title': 'Colección de Imágenes de Dron',
      'projects.drone.description': 'Fotografía y videografía aérea para bienes raíces, eventos y aplicaciones comerciales.',
      'projects.drone.overview': 'Professional aerial photography and videography services using advanced drone technology. Our drone footage captures stunning perspectives for real estate, events, construction projects, and commercial applications.',
      'projects.drone.challenge': 'Provide high-quality aerial footage that adds value to various industries while ensuring safety, compliance, and creative excellence.',
      'projects.drone.solution': 'Utilized professional drone equipment with advanced camera systems, experienced pilots, and post-production expertise to deliver cinematic aerial content.',
      'projects.drone.features': [
        '4K aerial photography and videography',
        'Real estate property showcases',
        'Event coverage and documentation',
        'Construction progress tracking',
        'Commercial and industrial applications',
        'Custom flight paths and angles',
        'Professional color grading and editing'
      ],
      'projects.drone.process': [
        'Site assessment and planning',
        'Weather and safety evaluation',
        'Drone flight and capture',
        'Post-production editing',
        'Color grading and enhancement',
        'Final delivery and optimization'
      ],
      'projects.drone.applications': [
        'Real Estate Marketing',
        'Event Documentation',
        'Construction Progress',
        'Tourism and Travel',
        'Commercial Advertising',
        'Property Inspection'
      ],
      'projects.drone.equipment': ['DJI Mavic 3 Pro', '4K Camera Systems', 'Professional Gimbal', 'Advanced Flight Controllers', 'Post-Production Software'],

      'projects.futuristic.title': 'Futuristic UI Concept',
      'projects.futuristic.description': 'An experimental UI design exploring futuristic interfaces and next-generation user experiences.',
      'projects.futuristic.overview': 'An experimental UI design project exploring futuristic interface concepts and next-generation user experiences. This project pushes the boundaries of traditional web design with innovative interactions, 3D elements, and cutting-edge technologies.',
      'projects.futuristic.challenge': 'Create a futuristic user interface that demonstrates innovative design concepts while maintaining usability and performance standards.',
      'projects.futuristic.solution': 'Developed an experimental UI using advanced web technologies including Three.js, WebGL, and modern CSS animations to create immersive and interactive experiences.',
      'projects.futuristic.features': [
        '3D interactive elements',
        'Advanced animations and transitions',
        'Gesture-based interactions',
        'Immersive visual effects',
        'Responsive design adaptation',
        'Performance optimization',
        'Cross-browser compatibility'
      ],
      'projects.futuristic.process': [
        'Concept development and research',
        '3D modeling and design',
        'Interactive prototype development',
        'Performance optimization',
        'Testing and refinement',
        'Documentation and showcase'
      ],
      'projects.futuristic.technologies': [
        'Figma for Design',
        'Three.js for 3D Graphics',
        'WebGL for Rendering',
        'GSAP for Animations',
        'React for Interface',
        'Webpack for Build'
      ],
      'projects.futuristic.innovations': [
        'Holographic UI Elements',
        'Voice-Activated Controls',
        'Gesture Recognition',
        'AI-Powered Interactions',
        'Immersive Environments',
        'Predictive Interfaces'
      ],

      'projects.animation.title': '3D Homepage Animation Prototype',
      'projects.animation.description': 'Interactive 3D animations and visual effects for modern web experiences.',
      'projects.animation.overview': 'A prototype showcasing the potential of 3D animations and visual effects in modern web design. This project demonstrates how 3D elements can enhance user engagement and create memorable online experiences.',
      'projects.animation.challenge': 'Create engaging 3D animations that enhance user experience without compromising website performance or accessibility.',
      'projects.animation.solution': 'Developed optimized 3D animations using Three.js and GSAP, focusing on performance, accessibility, and cross-device compatibility while creating visually stunning effects.',
      'projects.animation.features': [
        'Interactive 3D scene navigation',
        'Smooth animation transitions',
        'Responsive 3D elements',
        'Performance-optimized rendering',
        'Touch and mouse interactions',
        'Progressive enhancement',
        'Accessibility considerations'
      ],
      'projects.animation.process': [
        '3D concept and storyboarding',
        'Scene modeling and setup',
        'Animation development',
        'Performance optimization',
        'User testing and refinement',
        'Documentation and deployment'
      ],
      'projects.animation.technicalSpecs': [
        'Three.js for 3D Rendering',
        'GSAP for Animation Control',
        'WebGL for Hardware Acceleration',
        'Responsive Design Principles',
        'Progressive Web App Features',
        'Cross-Browser Compatibility'
      ],
      'projects.animation.applications': [
        'Interactive Product Showcases',
        'Immersive Brand Experiences',
        'Educational Visualizations',
        'Entertainment Platforms',
        'Virtual Tours',
        'Interactive Storytelling'
      ],

      // Process Page
      'process.title': 'Mi Proceso',
      'process.discovery.title': 'Descubrimiento y Planificación',
      'process.discovery.description': 'Aprendo sobre tu negocio, audiencia y objetivos para que podamos construir algo que funcione, no solo que se vea bonito.',
      'process.discovery.bullet1': 'Las empresas que definen personas de usuario claras convierten 2-5 veces más.',
      'process.discovery.bullet2': 'Hago preguntas como: ¿Cuál es tu oferta #1? ¿Qué hace que la gente dude en comprar?',
      'process.discovery.bullet3': 'Investigo a tus competidores y destaco lo que te hace diferente.',
      'process.design.title': 'Diseño y Desarrollo',
      'process.design.description': 'Creo un sitio web que es tanto hermoso como funcional, optimizado para conversiones y experiencia de usuario.',
      'process.design.bullet1': 'Diseño responsivo mobile-first que funciona en todos los dispositivos',
      'process.design.bullet2': 'Tiempos de carga rápidos y rendimiento optimizado',
      'process.design.bullet3': 'Llamadas a la acción claras y rutas de conversión',
      'process.launch.title': 'Lanzamiento y Optimización',
      'process.launch.description': 'Me aseguro de que todo funcione perfectamente y te ayudo a aprovechar al máximo tu nuevo sitio web.',
      'process.launch.bullet1': 'Pruebas exhaustivas en todos los dispositivos y navegadores',
      'process.launch.bullet2': 'Optimización SEO para mejor visibilidad',
      'process.launch.bullet3': 'Configuración de analytics para rastrear el rendimiento',

      // ScrollExperience Component
      'scrollExperience.hero.title': 'Cómo Construyo Sitios Web Que Realmente Funcionan',
      'scrollExperience.hero.subtitle': 'Aquí está el sistema paso a paso que uso para diseñar y desarrollar sitios web personalizados de alta conversión — construidos para velocidad, SEO, móvil y tus objetivos de negocio.',
      'scrollExperience.stats.stat1': 'El usuario promedio forma una opinión de tu sitio web en 0.05 segundos.',
      'scrollExperience.stats.stat2': 'Los sitios web mobile-first convierten 27% más que los no optimizados.',
      'scrollExperience.stats.stat3': 'Un retraso de 1 segundo en la carga de la página puede reducir las conversiones hasta en un 20%.',
      
      // Process Steps
      'scrollExperience.steps.discovery.title': 'Descubrimiento y Planificación',
      'scrollExperience.steps.discovery.description': 'Aprendo sobre tu negocio, audiencia y objetivos para que podamos construir algo que funcione, no solo que se vea bonito.',
      'scrollExperience.steps.discovery.fact1': 'Las empresas que definen personas de usuario claras convierten 2-5 veces más.',
      'scrollExperience.steps.discovery.fact2': 'Hago preguntas como: ¿Cuál es tu oferta #1? ¿Qué hace que la gente dude en comprar?',
      'scrollExperience.steps.discovery.fact3': 'Investigo a tus competidores y destaco lo que te hace diferente.',
      
      'scrollExperience.steps.design.title': 'Diseño y Maquetas',
      'scrollExperience.steps.design.description': 'Diseño un layout que refleje tu marca, mantenga a los usuarios comprometidos y los guíe hacia la acción — usando estrategias UX probadas.',
      'scrollExperience.steps.design.fact1': 'Los usuarios pasan 74% de su tiempo viendo las primeras dos pantallas de una página.',
      'scrollExperience.steps.design.fact2': 'Uso layouts basados en patrones Z y F, probados para guiar el ojo naturalmente hacia las CTAs.',
      'scrollExperience.steps.design.fact3': 'Creo diseños mobile-first — ya que más del 58% de todo el tráfico web viene de móviles.',
      
      'scrollExperience.steps.development.title': 'Desarrollo',
      'scrollExperience.steps.development.description': 'Programo tu sitio a mano para velocidad, SEO y responsividad — evitando plantillas sobrecargadas.',
      'scrollExperience.steps.development.fact1': 'Los sitios que cargan en menos de 2 segundos tienen una tasa de conversión 15% más alta.',
      'scrollExperience.steps.development.fact2': 'Uso HTML/CSS/JS limpio y herramientas como Lighthouse para mantener las puntuaciones de rendimiento altas.',
      'scrollExperience.steps.development.fact3': 'Construyo fundamentos SEO: encabezados apropiados, etiquetas alt de imágenes y datos estructurados cuando sea necesario.',
      
      'scrollExperience.steps.review.title': 'Revisión y Correcciones',
      'scrollExperience.steps.review.description': 'Te envío una versión de prueba para revisión y refinamos juntos hasta que esté perfectamente ajustada.',
      'scrollExperience.steps.review.fact1': 'Los clientes que participan en ciclos de retroalimentación están 80% más satisfechos con el producto final.',
      'scrollExperience.steps.review.fact2': 'Incluyo 1-2 rondas de revisiones en el proceso para afinar diseño, contenido y flujo.',
      
      'scrollExperience.steps.launch.title': 'Lanzamiento y Soporte',
      'scrollExperience.steps.launch.description': 'Lanzo el sitio, conecto tu dominio, agrego SSL, optimizo para búsquedas y ofrezco soporte opcional para cambios continuos.',
      'scrollExperience.steps.launch.fact1': 'Me aseguro de que tu sitio esté enviado a Google Search Console para indexación.',
      'scrollExperience.steps.launch.fact2': 'Pruebo la compatibilidad con navegadores/dispositivos.',
      'scrollExperience.steps.launch.fact3': 'El soporte post-lanzamiento ayuda con actualizaciones, analytics o ajustes de contenido — justo como un verdadero miembro del equipo.',
      
      // CTA Section
      'scrollExperience.cta.title': 'Ahora que has visto cómo lo hago — ¿quieres verlo en acción?',
      'scrollExperience.cta.subtitle': 'Construyamos algo poderoso juntos.',
      'scrollExperience.cta.button': 'Comenzar Proyecto',

      // Blog Page
      'blog.hero.title': 'Blog de FuturoCode',
      'blog.hero.subtitle': 'Perspectivas, consejos y estrategias para ayudar a tu negocio a prosperar en el mundo digital',
      'blog.search.placeholder': 'Buscar artículos...',
      'blog.noPosts.title': 'No se encontraron publicaciones',
      'blog.noPosts.subtitle': 'Intenta ajustar tu búsqueda o criterios de filtro',
      'blog.cta.title': '¿Quieres perspectivas como estas para tu negocio?',
      'blog.cta.subtitle': 'Trabajemos juntos para crear una estrategia digital que genere resultados',
      'blog.cta.button': 'Comenzar Proyecto',
      'blog.featured.badge': 'Publicación Destacada',
      'blog.readMore': 'Leer Más',
      'blog.readFullArticle': 'Leer Artículo Completo',

      // Blog Categories
      'blog.categories.all': 'Todas las Publicaciones',
      'blog.categories.webDesign': 'Diseño Web',
      'blog.categories.branding': 'Branding',
      'blog.categories.marketing': 'Marketing Digital',
      'blog.categories.cybersecurity': 'Ciberseguridad',
      'blog.categories.business': 'Consejos de Negocio',

      // Blog Posts
      'blog.posts.websiteLosingCustomers.title': 'Por Qué Tu Sitio Web Está Perdiendo Clientes (y Cómo Solucionarlo)',
      'blog.posts.websiteLosingCustomers.excerpt': 'Descubre los errores comunes en sitios web que alejan a los clientes potenciales y aprende estrategias probadas para convertir visitantes en clientes leales.',
      'blog.posts.websiteLosingCustomers.content': `
        En la era digital actual, tu sitio web es a menudo la primera impresión que los clientes potenciales tienen de tu negocio. Un sitio web mal diseñado o desactualizado puede costarte valiosos clientes antes de que tengas la oportunidad de mostrar tus productos o servicios. Veamos los errores comunes que pueden estar alejando a los visitantes y, más importante aún, cómo solucionarlos.

        1. Tiempos de Carga Lentos
        Los estudios muestran que el 53% de los usuarios móviles abandonan sitios que tardan más de 3 segundos en cargar. Aquí te mostramos cómo acelerar tu sitio:
        - Optimiza las imágenes y usa formatos modernos como WebP
        - Implementa estrategias de almacenamiento en caché
        - Minimiza archivos JavaScript y CSS
        - Utiliza una red de distribución de contenido (CDN)

        2. Mala Experiencia Móvil
        Con más del 60% del tráfico web proveniente de dispositivos móviles, un sitio web no optimizado para móviles es una gran desventaja. Las soluciones esenciales incluyen:
        - Implementar diseño responsivo que se adapte a todos los tamaños de pantalla
        - Asegurar que el texto sea legible sin necesidad de zoom
        - Hacer que los botones y enlaces sean fáciles de tocar
        - Probar tu sitio en múltiples dispositivos

        3. Propuesta de Valor Poco Clara
        Los visitantes deben entender inmediatamente qué ofreces y por qué deberían elegirte. Para mejorar:
        - Coloca tu propuesta de valor en la parte superior de la página
        - Usa títulos claros enfocados en beneficios
        - Incluye prueba social (testimonios, reseñas)
        - Destaca tus puntos únicos de venta

        4. Navegación Complicada
        Si los usuarios no pueden encontrar lo que buscan rápidamente, se irán. Las soluciones incluyen:
        - Simplificar la estructura del menú
        - Implementar una jerarquía clara
        - Agregar una función de búsqueda
        - Usar etiquetas descriptivas

        5. Falta de Llamados a la Acción (CTA) Claros
        Sin una dirección clara, los visitantes no sabrán qué hacer después. Mejora mediante:
        - Hacer los CTA visibles y convincentes
        - Usar lenguaje orientado a la acción
        - Colocar CTA estratégicamente en toda la página
        - Probar diferentes colores y posiciones

        6. Diseño Desactualizado
        Un sitio web desactualizado puede dañar tu credibilidad. Principios de diseño moderno a implementar:
        - Usar tipografía limpia y moderna
        - Implementar espacio en blanco adecuado
        - Elegir un esquema de colores contemporáneo
        - Agregar animaciones e interacciones sutiles

        7. Falta de Señales de Confianza
        Construye confianza con clientes potenciales mediante:
        - Mostrar insignias de seguridad
        - Mostrar testimonios de clientes
        - Incluir casos de estudio
        - Destacar certificaciones de la industria

        8. Mala Organización del Contenido
        El contenido bien organizado ayuda a los visitantes a encontrar información fácilmente:
        - Usar encabezados y subencabezados claros
        - Implementar jerarquía lógica de contenido
        - Dividir el texto con viñetas
        - Incluir imágenes y medios relevantes

        9. Falta de Optimización de Rendimiento
        Un sitio lento y no optimizado frustra a los usuarios. Optimizaciones clave:
        - Comprimir imágenes y medios
        - Minimizar solicitudes HTTP
        - Habilitar el almacenamiento en caché del navegador
        - Usar carga diferida para imágenes

        10. Sin Análisis ni Seguimiento
        Sin datos, no puedes mejorar. Implementa:
        - Google Analytics
        - Herramientas de mapeo de calor
        - Seguimiento de conversiones
        - Análisis de comportamiento del usuario

        Tomando Acción
        Comienza auditando tu sitio web contra estos problemas comunes. Prioriza las soluciones basándote en:
        1. Impacto en la experiencia del usuario
        2. Facilidad de implementación
        3. Retorno potencial de la inversión

        Recuerda, tu sitio web debe ser una herramienta poderosa para convertir visitantes en clientes, no una barrera de entrada. Las actualizaciones y el mantenimiento regulares son esenciales para mantener tu sitio funcionando en su mejor forma.

        ¿Necesitas ayuda para optimizar tu sitio web? Contáctanos para obtener una auditoría gratuita de tu sitio web y recomendaciones personalizadas para aumentar tus tasas de conversión.
      `,
      'blog.posts.websiteLosingCustomers.tags': ['Diseño Web', 'Experiencia de Usuario', 'Conversión'],

      'blog.posts.brandTrust.title': 'Cómo Construir una Marca en la Que la Gente Confíe',
      'blog.posts.brandTrust.excerpt': 'Aprende los elementos esenciales de la construcción de marca que crean confianza y lealtad duraderas con tu audiencia objetivo.',
      'blog.posts.brandTrust.content': 'Construir una marca confiable no se trata solo de tener un logo bonito o un eslogan pegajoso. Se trata de crear una experiencia consistente que se alinee con tus valores y resuene con tu audiencia...',
      'blog.posts.brandTrust.tags': ['Branding', 'Confianza', 'Identidad de Marca'],

      'blog.posts.cybersecurity101.title': 'Ciberseguridad 101: Protegiendo Tu Pequeña Empresa en Línea',
      'blog.posts.cybersecurity101.excerpt': 'Prácticas esenciales de ciberseguridad que todo propietario de pequeña empresa debe implementar para proteger sus activos digitales y datos de clientes.',
      'blog.posts.cybersecurity101.content': 'En el panorama digital actual, la ciberseguridad no es solo para grandes corporaciones. Las pequeñas empresas son cada vez más objetivo de cibercriminales, haciendo que las medidas de seguridad sean esenciales para la supervivencia...',
      'blog.posts.cybersecurity101.tags': ['Ciberseguridad', 'Pequeña Empresa', 'Protección de Datos'],

      'blog.posts.entrepreneurMistakes.title': '5 Errores Que Los Nuevos Emprendedores Cometen Con Su Presencia En Línea',
      'blog.posts.entrepreneurMistakes.excerpt': 'Evita estos errores comunes que pueden descarrilar el éxito en línea de tu negocio y aprende cómo construir una base digital sólida.',
      'blog.posts.entrepreneurMistakes.content': 'Comenzar un negocio es emocionante, pero muchos nuevos emprendedores cometen errores críticos con su presencia en línea que pueden obstaculizar el crecimiento y el éxito...',
      'blog.posts.entrepreneurMistakes.tags': ['Emprendimiento', 'Presencia En Línea', 'Estrategia de Negocio'],

      'blog.posts.localSEO.title': 'El Poder del SEO Local para Empresas de Servicios',
      'blog.posts.localSEO.excerpt': 'Domina la optimización de búsqueda local para dominar tu mercado local y atraer clientes en tu área.',
      'blog.posts.localSEO.content': 'Para las empresas de servicios, el SEO local puede ser la diferencia entre prosperar y luchar. Cuando los clientes potenciales buscan servicios en tu área, quieres ser la primera empresa que vean...',
      'blog.posts.localSEO.tags': ['SEO Local', 'Marketing Digital', 'Negocio Local'],

      'blog.posts.designTrends2025.title': 'Tendencias de Diseño Que Dominarán 2025',
      'blog.posts.designTrends2025.excerpt': 'Mantente a la vanguardia con estas tendencias de diseño emergentes que darán forma al panorama digital en 2025.',
      'blog.posts.designTrends2025.content': 'El mundo del diseño está en constante evolución, y mantenerse actualizado con las tendencias es crucial para las empresas que quieren mantener una ventaja competitiva...',
      'blog.posts.designTrends2025.tags': ['Tendencias de Diseño', '2025', 'Diseño Web'],

      'blog.posts.contentMarketing.title': 'Construyendo una Estrategia de Marketing de Contenido Que Convierte',
      'blog.posts.contentMarketing.excerpt': 'Crea contenido convincente que no solo atraiga a tu audiencia sino que también los impulse a tomar acción.',
      'blog.posts.contentMarketing.content': 'El marketing de contenido es más que solo crear publicaciones de blog. Se trata de desarrollar una estrategia integral que eduque, entretenga y convierta a tu audiencia...',
      'blog.posts.contentMarketing.tags': ['Marketing de Contenido', 'Estrategia', 'Conversión'],

      'blog.posts.colorPsychology.title': 'La Psicología del Color en el Diseño de Marca',
      'blog.posts.colorPsychology.excerpt': 'Comprende cómo las elecciones de color influyen en la percepción del cliente y la toma de decisiones en tu diseño de marca.',
      'blog.posts.colorPsychology.content': 'Los colores tienen un impacto profundo en la psicología humana y pueden influir significativamente en cómo los clientes perciben e interactúan con tu marca...',
      'blog.posts.colorPsychology.tags': ['Psicología del Color', 'Diseño de Marca', 'Diseño Visual'],

      // Individual Services
      'services.webdesign.title': 'Diseño y Desarrollo Web',
      'services.webdesign.description': 'Sitios web personalizados y responsivos que están optimizados para SEO, son rápidos y construidos para conversiones.',
      'services.webdesign.features': ['Diseño Responsivo', 'Optimización SEO', 'Enfoque en Rendimiento', 'Orientado a Conversión'],
      'services.webdesign.overview': 'Creamos sitios web impresionantes y de alto rendimiento que no solo se ven geniales sino que también generan resultados. Nuestro proceso de desarrollo se enfoca en la experiencia del usuario, optimización para motores de búsqueda y optimización de conversión.',
      'services.webdesign.benefits': [
        'Diseño responsivo mobile-first que funciona en todos los dispositivos',
        'Código y contenido optimizado para SEO para mejores rankings de búsqueda',
        'Tiempos de carga rápidos y rendimiento optimizado',
        'Diseño enfocado en conversión que convierte visitantes en clientes',
        'Código moderno y limpio que es fácil de mantener y actualizar'
      ],
      'services.webdesign.process': [
        'Descubrimiento y Planificación',
        'Diseño y Wireframing', 
        'Desarrollo y Pruebas',
        'Lanzamiento y Optimización'
      ],
      'services.webdesign.technologies': ['React', 'Next.js', 'WordPress', 'Shopify', 'PHP Personalizado', 'Node.js'],

      'services.branding.title': 'Identidad de Marca y Diseño de Logo',
      'services.branding.description': 'Logos, guías de marca y paquetes de identidad visual que hacen que tu negocio sea memorable.',
      'services.branding.features': ['Diseño de Logo', 'Guías de Marca', 'Identidad Visual', 'Guías de Estilo'],
      'services.branding.overview': 'Tu marca es más que solo un logo. Creamos sistemas integrales de identidad de marca que comunican tus valores, te diferencian de la competencia y construyen confianza con tu audiencia.',
      'services.branding.benefits': [
        'Diseño de logo profesional que representa los valores de tu marca',
        'Guías de marca integrales para aplicación consistente',
        'Sistema de identidad visual incluyendo colores, tipografía e imágenes',
        'Guías de estilo para todos los materiales de marketing',
        'Estrategia de marca que se alinea con tus objetivos empresariales'
      ],
      'services.branding.process': [
        'Investigación y Estrategia de Marca',
        'Diseño de Logo y Conceptos',
        'Desarrollo de Identidad Visual',
        'Creación de Guías de Marca'
      ],
      'services.branding.deliverables': ['Logos Primarios y Secundarios', 'PDF de Guías de Marca', 'Paleta de Colores', 'Sistema de Tipografía', 'Diseño de Tarjetas de Negocio', 'Plantillas para Redes Sociales'],

      'services.video.title': 'Producción de Video y Comerciales',
      'services.video.description': 'Videos promocionales, contenido de YouTube, imágenes de dron y comerciales empresariales que cuentan tu historia.',
      'services.video.features': ['Videos Promocionales', 'Contenido de YouTube', 'Imágenes de Dron', 'Comerciales Empresariales'],
      'services.video.overview': 'El contenido de video es la forma más atractiva de medios. Producimos videos de alta calidad que capturan la atención, cuentan tu historia e impulsan la acción de tu audiencia.',
      'services.video.benefits': [
        'Producción de video profesional para todas las plataformas',
        'Contenido atractivo que aumenta la conciencia de marca',
        'Imágenes de dron para perspectivas aéreas únicas',
        'Contenido optimizado para YouTube para mayor alcance',
        'Calidad de producción de nivel comercial'
      ],
      'services.video.process': [
        'Desarrollo de Concepto',
        'Escritura de Guión y Storyboarding',
        'Filmación y Producción',
        'Edición y Post-Producción'
      ],
      'services.video.services': ['Videos Promocionales', 'Demostraciones de Producto', 'Resúmenes de Empresa', 'Videos de Testimonios', 'Fotografía con Dron', 'Contenido de YouTube', 'Videos para Redes Sociales', 'Comerciales de TV'],

      'services.marketing.title': 'Marketing Digital y Estrategia',
      'services.marketing.description': 'Estrategia de redes sociales, páginas de aterrizaje listas para anuncios, SEO local y crecimiento de presencia online.',
      'services.marketing.features': ['Estrategia de Redes Sociales', 'Páginas de Aterrizaje', 'SEO Local', 'Marketing de Crecimiento'],
      'services.marketing.overview': 'Marketing digital estratégico que impulsa el crecimiento empresarial real. Creamos campañas basadas en datos que aumentan tu visibilidad online, generan leads e impulsan ventas.',
      'services.marketing.benefits': [
        'Estrategias de marketing basadas en datos que generan resultados',
        'Presencia en redes sociales que involucra a tu audiencia',
        'SEO local para dominar tu mercado local',
        'Páginas de aterrizaje de alta conversión para campañas',
        'Optimización continua y seguimiento de crecimiento'
      ],
      'services.marketing.process': [
        'Investigación y Análisis de Mercado',
        'Desarrollo de Estrategia',
        'Implementación de Campaña',
        'Monitoreo y Optimización'
      ],
      'services.marketing.services': ['Gestión de Redes Sociales', 'Google Ads y PPC', 'Anuncios de Facebook e Instagram', 'Optimización SEO Local', 'Diseño de Páginas de Aterrizaje', 'Email Marketing', 'Marketing de Contenido', 'Análisis e Informes'],

      'services.automation.title': 'Automatización Empresarial',
      'services.automation.description': 'Configuración de CRM, formularios de incorporación de clientes, reserva automática de citas y chatbots.',
      'services.automation.features': ['Configuración de CRM', 'Incorporación de Clientes', 'Reserva de Citas', 'Chatbots'],
      'services.automation.overview': 'Automatiza tus procesos empresariales para ahorrar tiempo, reducir errores y mejorar la experiencia del cliente. Configuraremos sistemas que funcionan 24/7 para hacer crecer tu negocio.',
      'services.automation.benefits': [
        'Gestión automatizada de relaciones con clientes',
        'Proceso de incorporación de clientes optimizado',
        'Sistema de reserva de citas 24/7',
        'Chatbots inteligentes para soporte al cliente',
        'Reducción del trabajo manual y errores humanos'
      ],
      'services.automation.process': [
        'Análisis de Procesos',
        'Diseño de Sistema',
        'Implementación y Pruebas',
        'Capacitación y Lanzamiento'
      ],
      'services.automation.tools': ['HubSpot CRM', 'Zapier', 'Calendly', 'Intercom', 'Mailchimp', 'Slack', 'Trello', 'Asana'],

      'services.cybersecurity.title': 'Ciberseguridad y Mejores Prácticas',
      'services.cybersecurity.description': 'Endurecimiento de seguridad integral, configuración SSL y orientación sobre manejo seguro de datos.',
      'services.cybersecurity.features': ['Endurecimiento de Seguridad', 'Configuración SSL', 'Protección de Datos', 'Monitoreo de Seguridad'],
      'services.cybersecurity.overview': 'Protege tu negocio y datos de clientes con soluciones de ciberseguridad de nivel empresarial. Implementamos las mejores prácticas de la industria para asegurar tus activos digitales y mantener el cumplimiento.',
      'services.cybersecurity.benefits': [
        'Seguridad mejorada del sitio web con mejores prácticas de la industria',
        'Configuración y gestión de certificados SSL',
        'Manejo seguro de datos y cumplimiento de privacidad',
        'Monitoreo de seguridad en tiempo real y detección de amenazas',
        'Auditorías de seguridad regulares y evaluaciones de vulnerabilidades'
      ],
      'services.cybersecurity.process': [
        'Evaluación de Seguridad',
        'Implementación y Endurecimiento',
        'Configuración de Monitoreo',
        'Protección Continua'
      ],
      'services.cybersecurity.services': [
        'Endurecimiento Básico de Seguridad del Sitio',
        'Configuración y Gestión de Certificados SSL',
        'Configuración de Seguridad de Dominio',
        'Pautas de Manejo Seguro de Datos',
        'Integraciones de Monitoreo de Seguridad',
        'Evaluaciones de Vulnerabilidades',
        'Desarrollo de Políticas de Seguridad',
        'Orientación de Cumplimiento'
      ],

      'services.maintenance.title': 'Mantenimiento y Soporte Continuo',
      'services.maintenance.description': 'Mantenimiento integral del sitio web, monitoreo de seguridad y paquetes de soporte continuo.',
      'services.maintenance.features': ['Actualizaciones del Sitio', 'Monitoreo de Seguridad', 'Monitoreo de Rendimiento', 'Soporte de Retenedor'],
      'services.maintenance.overview': 'Mantén tu sitio web funcionando sin problemas con nuestros servicios integrales de mantenimiento y soporte. Nos encargamos de todo, desde actualizaciones regulares hasta correcciones de emergencia, para que puedas enfocarte en tu negocio.',
      'services.maintenance.benefits': [
        'Mantenimiento proactivo del sitio web y actualizaciones',
        'Monitoreo de seguridad 24/7 y respuesta a amenazas',
        'Optimización de rendimiento y monitoreo de velocidad',
        'Soporte prioritario y correcciones de errores de emergencia',
        'Opciones flexibles de retenedor para soporte continuo'
      ],
      'services.maintenance.process': [
        'Evaluación Inicial',
        'Configuración del Plan de Mantenimiento',
        'Monitoreo y Actualizaciones Regulares',
        'Informes Mensuales y Optimización'
      ],
      'services.maintenance.services': [
        'Actualizaciones y Cambios del Sitio Web',
        'Monitoreo de Seguridad y Respuesta a Amenazas',
        'Monitoreo de Rendimiento y Optimización',
        'Correcciones de Errores y Soporte Técnico',
        'Actualizaciones y Gestión de Contenido',
        'Gestión de Respaldo y Recuperación',
        'Revisión de Análisis e Informes',
        'Opciones de Retenedor para Soporte Continuo'
      ],

      // Maintenance Package Features
      'maintenance.basic.features': [
        'Hasta 1 hora de actualizaciones/mes (cambios de texto, imágenes, ajustes menores)',
        'Verificación mensual de seguridad y rendimiento',
        'Actualizaciones básicas de plugins/temas',
        'Soporte por email (respuesta en 48-72 horas)'
      ],
      'maintenance.standard.features': [
        'Hasta 3 horas de actualizaciones/mes',
        'Escaneo de seguridad + optimización de rendimiento',
        'Cambios menores de diseño o contenido',
        'Informe resumen de análisis',
        'Soporte prioritario por email (respuesta en 24-48 horas)'
      ],
      'maintenance.premium.features': [
        'Hasta 5-8 horas de actualizaciones/mes',
        'Informes mensuales de análisis + recomendaciones',
        'Mejoras menores de SEO',
        'Ajustes proactivos de rendimiento',
        'Soporte prioritario (mismo día o día siguiente)',
        'Correcciones de emergencia incluidas (dentro de lo razonable)'
      ]
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n; 